import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import qrcode from "qrcode-js";
import { encode } from "base64-arraybuffer";
import {
  generateEAN13,
  generateItemReference,
  validateEAN13,
  epcToEAN13,
} from "../../../../utils/ean13Generator";

// Calcula el RFID (EAN-13) de una pieza a partir de su modelo, color y talla.
// Debe coincidir con el RFID impreso en la etiqueta (ver ListadoArticulos.jsx -> QRGen).
function calculaRFID(codigo, color, talla) {
  try {
    return generateEAN13(generateItemReference(codigo, color, talla));
  } catch (e) {
    return "";
  }
}

function VentasTiendasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_INVENTARIOS = import.meta.env.VITE_URL_INVENTARIOS;
  const URL_COLABORADORES = import.meta.env.VITE_URL_COLABORADORES;
  const URL_CLIENTES = import.meta.env.VITE_URL_CLIENTES;
  const URL_VENTAS_TIENDAS = import.meta.env.VITE_URL_VENTAS_TIENDAS;
  const URL_ARTICULOS_VENTAS_TIENDAS =
    import.meta.env.VITE_URL_ARTICULOS_VENTAS_TIENDAS;
  const URL_ABONOS_TIENDAS = import.meta.env.VITE_URL_ABONOS_TIENDAS;
  const URL_AREAS = import.meta.env.VITE_URL_AREAS;
  const URL_SEND_MAIL = import.meta.env.VITE_URL_SEND_MAIL;
  const URL_PAQUETERIAS = import.meta.env.VITE_URL_PAQUETERIAS;
  const URL_GRUPOS = import.meta.env.VITE_URL_GRUPOS;
  const URL_DEPARTAMENTOS_CLIENTES =
    import.meta.env.VITE_URL_DEPARTAMENTOS_CLIENTES;
  const URL_WHATSAPP = import.meta.env.VITE_URL_WHATSAPP;
  const URL_ARTICULOS_PROPORCION =
    import.meta.env.VITE_URL_ARTICULOS_PROPORCION;
  const CLIENTES_DIVERSOS = import.meta.env.VITE_CLIENTE_DIVERSOS;
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;
  const URL_BANCOS = import.meta.env.VITE_URL_BANCOS;
  const URL_CAJAS = import.meta.env.VITE_URL_CAJAS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");
  let hora = moment(date).format("HH:mm:ss");

  const [clientes, setClientes] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedColaboradorName, setSelectedColaboradorName] = useState("");
  const [value, setValue] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);

  const [expandedTables, setExpandedTables] = useState({});

  const [paqueterias, setPaqueterias] = useState([]);
  const [idPaqueteria, setIdPaqueteria] = useState("647e2090513ca00014b4edbc");
  const [bancos, setBancos] = useState([]);
  const [cajas, setCajas] = useState([]);
  const [caja, setCaja] = useState("");
  const [inventarios, setInventarios] = useState([]);
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedAreaName, setSelectedAreaName] = useState("");
  const [comisionTDC, setComisionTDC] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);
  const [descuento, setDescuento] = useState(0);
  const [descuentoTipo, setDescuentoTipo] = useState("%");
  const [articulosUnicos, setArticulosUnicos] = useState([]);
  const [codigoAgrupado, setCodigoAgrupado] = useState(uuidv4());

  const [fecha, setFecha] = useState(hoy);
  const [condPago, setCondPago] = useState("Contado");
  const [observaciones, setObservaciones] = useState("NA");
  const [urlPhoto, setUrlPhoto] = useState("");

  function jalaFoto(idArticulo, urlFoto) {
    setUrlPhoto("");
    if (!idArticulo || !urlFoto || urlFoto === "No") return;
    const URL_GET_MEDIA = `${import.meta.env.VITE_URL_GETMEDIA}/${idArticulo}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        if (data.data.secure_url) {
          setUrlPhoto(data.data.secure_url);
        }
      })
      .catch((err) => console.log(err));
  }
  const [total_general, setTotalGeneral] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [selectedImpuesto, setSelectedImpuesto] = useState(16);
  const [alertasCliente, setAlertasCliente] = useState("No");
  const [listaPrecios, setListaPrecios] = useState(1);

  const [efectivo, setEfectivo] = useState(0);
  const [tdc, setTDC] = useState(0);
  const [transfer, setTransfer] = useState(0);
  const [deposito, setDeposito] = useState(0);
  const [destinoDeposito, setDestinoDeposito] = useState("NA");
  const [fechaDeposito, setFechaDeposito] = useState("NA");
  const [cheque, setCheque] = useState(0);
  const [destinoCheque, setDestinoCheque] = useState("NA");
  const [fechaCheque, setFechaCheque] = useState("NA");
  const [numeroCheque, setNumeroCheque] = useState("NA");
  const [fechaTransfer, setFechaTransfer] = useState("NA");
  const [destino, setDestino] = useState("NA");
  const [terminal, setTerminal] = useState("NA");
  const [fiscal, setFiscal] = useState("No");
  const [saldo, setSaldo] = useState(0);


  const [inputFields, setInputFields] = useState([]);

  const [manualInput, setManualInput] = useState({
    articulosNombre: "",
    articulos: "",
    idColor: "",
    idTalla: "",
    tallaNombre: "",
    cantInv: 0,
    cantidad: 0,
    colores: [],
    tallas: [],
    total: 0,
    idProporcion: "",
  });

  const [inputArticulos, setInputArticulos] = useState([
    {
      id: uuidv4(),
      articulos: "",
      cajas: 0,
      precio: 0,
      articulosNombre: "",
      colores: [],
      tallas: [],
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);
  const submittingRef = useRef(false);
  const [cambiarPrecio, setCambiarPrecio] = useState(false);

  const [modalCambiaPrecio, setModalCambiaPrecio] = useState(false);
  const toggleCambiaPrecio = () => setModalCambiaPrecio(!modalCambiaPrecio);

  const [modalAltaCliente, setModalAltaCliente] = useState(false);
  const toggleAltaCliente = () => setModalAltaCliente(!modalAltaCliente);
  const [password, setPassword] = useState("");

  const [mailAutEnviado, setMailAutEnviado] = useState(false);
  const [randomCambiaPrecio, setRandomCambiaPrecio] = useState(
    (Math.random() + 1).toString(36).substring(2)
  );

  // Crear Clientes
  const [vistaCliente, setVistaCliente] = useState(false);
  const [nombre_comercial, setNombreComercial] = useState("");
  const [razon_social, setRazonSocial] = useState("NA");
  const [RFC, setRFC] = useState("NA");
  const [calle, setCalle] = useState("NA");
  const [numero_ext, setNumeroExt] = useState("NA");
  const [numero_int, setNumeroInt] = useState("NA");
  const [delegacion, setDelegacion] = useState("NA");
  const [estado, setEstado] = useState("NA");
  const [pais, setPais] = useState("Mexico");
  const [cp, setCP] = useState(0);
  const [colonia, setColonia] = useState("NA");
  const [ciudad, setCiudad] = useState("NA");
  const [plazo, setPlazo] = useState(0);
  const [regFiscal, setRegFiscal] = useState("0");
  const [usoCFDI, setUsoCFDI] = useState("G01");
  const [formaPagoSAT, setFormaPagoSAT] = useState("01");
  const [condicionesPagoSAT, setCondicionesPagoSAT] = useState("NA");
  const [metodoPagoSAT, setMetodoPagoSAT] = useState("PUE");
  const [telefono, setTelefono] = useState("1");
  const [email, setEmail] = useState("a@a.a");
  const [grupos, setGrupos] = useState([]);
  const [selectedGrupo, setSelectedGrupo] = useState("");
  const [departamentos, setDepartamentos] = useState([]);
  const [selectedDepartamento, setSelectedDepartamento] = useState("");
  const [selectedPaqueteria, setSelectedPaqueteria] = useState(
    "647e2090513ca00014b4edbc"
  );
  const [selectedAreaCliente, setSelectedAreaCliente] = useState("");
  const [selectedVendedorInput, setSelectedVendedorInput] = useState("");
  const [selectedVendedor, setSelectedVendedor] = useState("");
  const [observacionesCliente, setObservacionesCliente] = useState("NA");
  const [forma_pago, setFormaPago] = useState("Contado");
  const [descuentoCliente, setDescuentoCliente] = useState(0);

  const [areaUserName, setAreaUserName] = useState("");

  // ── Cache corte de luz ──────────────────────────────────────────────────────
  const ventaCacheKey = `venta_tienda_${user._id}`;
  const restoredFromCacheRef = useRef(false);
  const rfidScanRef = useRef(null);
  // Lectura RFID masiva: cada tag (EPC) es UNA pieza fisica.
  //  - epcLeidosRef: EPC -> idArticuloProporcion del renglon donde se conto.
  //    Evita contar dos veces el mismo tag cuando el lector lo reporta varias veces.
  const epcLeidosRef = useRef(new Map());
  const [rfidStats, setRfidStats] = useState({
    leidas: 0,
    repetidas: 0,
    noEncontradas: 0,
  });
  // Para tags RFID el aviso es un toast: un modal le quita el foco al campo y
  // las lecturas siguientes del lector se pierden. QR/teclado conserva el modal.
  const alertaEscaneo = (esTagRFID, opts) =>
    Swal.fire(
      esTagRFID
        ? {
            toast: true,
            position: "top-end",
            icon: opts.icon,
            title: opts.text || opts.title,
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
          }
        : opts
    );
  const [cacheChecked, setCacheChecked] = useState(false);
  // ────────────────────────────────────────────────────────────────────────────

  useMemo(() => {
    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });

    setAreaUserName(user.areaName);

    if (user && user.areas !== undefined) {
      setSelectedArea(user.areas);
      setSelectedAreaCliente(user.areas);

      axios
        .get(`${URL_CLIENTES}Activos`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allClientes = res.data;
          setClientes(allClientes);
        })
        .catch((err) => {
          console.log(err);
        });

      axios
        .get(`${URL_INVENTARIOS}VentaTienda/${user.areas}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          // Precalcula el RFID de cada pieza para poder escanear la etiqueta
          const allInventarios = res.data.map((a) => ({
            ...a,
            rfid: a.rfid !== undefined ? a.rfid : calculaRFID(a.codigo, a.color, a.talla),
          }));
          setInventarios(allInventarios);
          setSelectedAreaName(res.data[0].area);
          let unicos = allInventarios.filter(
            (value, index, self) =>
              index ===
              self.findIndex(
                (t) => t.idArticulo === value.idArticulo && t.cantidad > 0
              )
          );

          setArticulosUnicos(unicos);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // Depende solo de `user`: adentro no se lee ni selectedArea ni
    // selectedColaborador, los dos se ESCRIBEN aqui o al elegir cliente. Con
    // ellos en la lista, areas + clientes + inventarios se volvian a pedir tres
    // veces por cada carga de pantalla, y otra vez en cada cambio de cliente.
    // Eso era buena parte de los ~3s que tardaba en quedar lista la pantalla.
  }, [user]);

  useEffect(() => {
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_PAQUETERIAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allPaqueterias = res.data;
        setPaqueterias(allPaqueterias);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_GRUPOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allGrupos = res.data;
        setGrupos(allGrupos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_DEPARTAMENTOS_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allDepartamentos = res.data;
        setDepartamentos(allDepartamentos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
        const customeSizeOrder = allTallas.map((t) => t.name);
        setCustomSizeOrder(customeSizeOrder);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setBancos(res.data.filter((b) => b.is_active === "Si"));
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // Efecto aparte (no en el [] de arriba): AuthContext restaura `user` de
  // forma asincrona en un refresh directo a esta pantalla, asi que en el
  // primer render `user.areas` todavia es undefined. Este efecto se vuelve a
  // correr en cuanto `user.areas` ya tiene el valor real.
  useEffect(() => {
    if (!user.areas) return;
    axios
      .get(`${URL_CAJAS}Area/${user.areas}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const activas = res.data.filter((c) => c.is_active === "Si");
        setCajas(activas);
        if (user.cajaId && activas.some((c) => c._id === user.cajaId)) {
          setCaja(user.cajaId);
        } else if (activas.length === 1) {
          setCaja(activas[0]._id);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [user.areas]);

  useEffect(() => {
    ActualizaTotales();
  }, [inputFields, descuento, descuentoTipo, efectivo, tdc, transfer, deposito, cheque, selectedImpuesto]);

  useEffect(() => {
    setSaldo(parseFloat((total_general - efectivo - tdc - transfer - deposito - cheque).toFixed(2)));
  }, [total_general, efectivo, tdc, transfer, deposito, cheque]);

  // ── useEffect: verificar cache al montar (corte de luz) ────────────────────
  useEffect(() => {
    const saved = localStorage.getItem(ventaCacheKey);
    if (!saved) {
      setCacheChecked(true);
      return;
    }
    Swal.fire({
      title: "Venta en progreso",
      text: "Tienes una venta sin terminar. ¿Deseas continuarla?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, continuar",
      cancelButtonText: "No, empezar nueva",
    }).then((result) => {
      if (result.isConfirmed) {
        const data = JSON.parse(saved);
        restoredFromCacheRef.current = true;
        if (data.value !== undefined) setValue(data.value);
        if (data.fecha !== undefined) setFecha(data.fecha);
        if (data.condPago !== undefined) setCondPago(data.condPago);
        if (data.observaciones !== undefined) setObservaciones(data.observaciones);
        if (data.selectedColaborador !== undefined) setSelectedColaborador(data.selectedColaborador);
        if (data.selectedColaboradorName !== undefined) setSelectedColaboradorName(data.selectedColaboradorName);
        if (data.idPaqueteria !== undefined) setIdPaqueteria(data.idPaqueteria);
        if (data.selectedImpuesto !== undefined) setSelectedImpuesto(data.selectedImpuesto);
        if (data.listaPrecios !== undefined) setListaPrecios(data.listaPrecios);
        if (data.fiscal !== undefined) setFiscal(data.fiscal);
        if (data.saldo !== undefined) setSaldo(data.saldo);
        if (data.codigoAgrupado !== undefined) setCodigoAgrupado(data.codigoAgrupado);
        if (data.alertasCliente !== undefined) setAlertasCliente(data.alertasCliente);
        if (data.efectivo !== undefined) setEfectivo(data.efectivo);
        if (data.tdc !== undefined) setTDC(data.tdc);
        if (data.transfer !== undefined) setTransfer(data.transfer);
        if (data.deposito !== undefined) setDeposito(data.deposito);
        if (data.destinoDeposito !== undefined) setDestinoDeposito(data.destinoDeposito);
        if (data.fechaDeposito !== undefined) setFechaDeposito(data.fechaDeposito);
        if (data.cheque !== undefined) setCheque(data.cheque);
        if (data.destinoCheque !== undefined) setDestinoCheque(data.destinoCheque);
        if (data.fechaCheque !== undefined) setFechaCheque(data.fechaCheque);
        if (data.numeroCheque !== undefined) setNumeroCheque(data.numeroCheque);
        if (data.fechaTransfer !== undefined) setFechaTransfer(data.fechaTransfer);
        if (data.destino !== undefined) setDestino(data.destino);
        if (data.terminal !== undefined) setTerminal(data.terminal);
        if (data.comisionTDC !== undefined) setComisionTDC(data.comisionTDC);
        if (data.comisionFlete !== undefined) setComisionFlete(data.comisionFlete);
        if (data.inputFields !== undefined) setInputFields(data.inputFields);
        if (data.inputArticulos !== undefined) setInputArticulos(data.inputArticulos);
        if (data.total_general !== undefined) setTotalGeneral(data.total_general);
        if (data.subTotal !== undefined) setSubTotal(data.subTotal);
        if (data.iva !== undefined) setIva(data.iva);
        if (data.total_cantidad !== undefined) setTotalCantidad(data.total_cantidad);
        if (data.vistaCliente !== undefined) setVistaCliente(data.vistaCliente);
        if (data.nombre_comercial !== undefined) setNombreComercial(data.nombre_comercial);
        if (data.razon_social !== undefined) setRazonSocial(data.razon_social);
        if (data.RFC !== undefined) setRFC(data.RFC);
        if (data.calle !== undefined) setCalle(data.calle);
        if (data.numero_ext !== undefined) setNumeroExt(data.numero_ext);
        if (data.numero_int !== undefined) setNumeroInt(data.numero_int);
        if (data.delegacion !== undefined) setDelegacion(data.delegacion);
        if (data.estado !== undefined) setEstado(data.estado);
        if (data.pais !== undefined) setPais(data.pais);
        if (data.cp !== undefined) setCP(data.cp);
        if (data.colonia !== undefined) setColonia(data.colonia);
        if (data.ciudad !== undefined) setCiudad(data.ciudad);
        if (data.plazo !== undefined) setPlazo(data.plazo);
        if (data.regFiscal !== undefined) setRegFiscal(data.regFiscal);
        if (data.usoCFDI !== undefined) setUsoCFDI(data.usoCFDI);
        if (data.formaPagoSAT !== undefined) setFormaPagoSAT(data.formaPagoSAT);
        if (data.condicionesPagoSAT !== undefined) setCondicionesPagoSAT(data.condicionesPagoSAT);
        if (data.metodoPagoSAT !== undefined) setMetodoPagoSAT(data.metodoPagoSAT);
        if (data.telefono !== undefined) setTelefono(data.telefono);
        if (data.email !== undefined) setEmail(data.email);
        if (data.selectedGrupo !== undefined) setSelectedGrupo(data.selectedGrupo);
        if (data.selectedDepartamento !== undefined) setSelectedDepartamento(data.selectedDepartamento);
        if (data.selectedPaqueteria !== undefined) setSelectedPaqueteria(data.selectedPaqueteria);
        if (data.selectedAreaCliente !== undefined) setSelectedAreaCliente(data.selectedAreaCliente);
        // Lo recuperado de una venta a medias cuenta como elegido a mano: no
        // se lo debe tapar el vendedor por defecto del cliente.
        if (data.selectedVendedor !== undefined) { setSelectedVendedor(data.selectedVendedor); vendedorTocadoRef.current = true; }
        if (data.selectedVendedorInput !== undefined) setSelectedVendedorInput(data.selectedVendedorInput);
        if (data.observacionesCliente !== undefined) setObservacionesCliente(data.observacionesCliente);
        if (data.forma_pago !== undefined) setFormaPago(data.forma_pago);
        if (data.descuentoCliente !== undefined) setDescuentoCliente(data.descuentoCliente);
        if (data.descuento !== undefined) setDescuento(data.descuento);
        if (data.descuentoTipo !== undefined) setDescuentoTipo(data.descuentoTipo);
        if (data.caja !== undefined) setCaja(data.caja);
      } else {
        localStorage.removeItem(ventaCacheKey);
      }
      setCacheChecked(true);
    });
  }, []);
  // ──────────────────────────────────────────────────────────────────────────

  // ── useEffect: guardar automáticamente en cache (corte de luz) ────────────
  useEffect(() => {
    if (!cacheChecked) return;
    if (inputFields.length === 0) {
      localStorage.removeItem(ventaCacheKey);
      return;
    }
    const data = {
      value,
      fecha,
      condPago,
      observaciones,
      selectedColaborador,
      selectedColaboradorName,
      idPaqueteria,
      selectedImpuesto,
      listaPrecios,
      fiscal,
      saldo,
      codigoAgrupado,
      alertasCliente,
      efectivo,
      tdc,
      transfer,
      deposito,
      destinoDeposito,
      fechaDeposito,
      cheque,
      destinoCheque,
      fechaCheque,
      numeroCheque,
      fechaTransfer,
      destino,
      terminal,
      comisionTDC,
      comisionFlete,
      descuento,
      descuentoTipo,
      inputFields,
      inputArticulos,
      total_general,
      subTotal,
      iva,
      total_cantidad,
      vistaCliente,
      nombre_comercial,
      razon_social,
      RFC,
      calle,
      numero_ext,
      numero_int,
      delegacion,
      estado,
      pais,
      cp,
      colonia,
      ciudad,
      plazo,
      regFiscal,
      usoCFDI,
      formaPagoSAT,
      condicionesPagoSAT,
      metodoPagoSAT,
      telefono,
      email,
      selectedGrupo,
      selectedDepartamento,
      selectedPaqueteria,
      selectedAreaCliente,
      selectedVendedor,
      selectedVendedorInput,
      observacionesCliente,
      forma_pago,
      descuentoCliente,
      caja,
    };
    localStorage.setItem(ventaCacheKey, JSON.stringify(data));
  }, [
    cacheChecked,
    value, fecha, condPago, observaciones, selectedColaborador, selectedColaboradorName,
    idPaqueteria, selectedImpuesto, listaPrecios, fiscal, saldo, codigoAgrupado, alertasCliente,
    efectivo, tdc, transfer, deposito, destinoDeposito, fechaDeposito,
    cheque, destinoCheque, fechaCheque, numeroCheque, fechaTransfer, destino, terminal, comisionTDC, comisionFlete, descuento, descuentoTipo,
    inputFields, inputArticulos, total_general, subTotal, iva, total_cantidad,
    vistaCliente, nombre_comercial, razon_social, RFC, calle, numero_ext, numero_int,
    delegacion, estado, pais, cp, colonia, ciudad, plazo, regFiscal, usoCFDI, formaPagoSAT,
    condicionesPagoSAT, metodoPagoSAT, telefono, email, selectedGrupo, selectedDepartamento,
    selectedPaqueteria, selectedAreaCliente, selectedVendedor, selectedVendedorInput,
    observacionesCliente, forma_pago, descuentoCliente, caja,
  ]);
  // ──────────────────────────────────────────────────────────────────────────

  // En cuanto la cajera elige un vendedor a mano, ya nadie se lo cambia solo.
  const vendedorTocadoRef = useRef(false);
  // Los valores de mostrador se ponen una sola vez por carga de pantalla.
  const defaultsAplicadosRef = useRef(false);

  // El id que se guarda, el texto del combo y el nombre que sale en el ticket
  // tienen que moverse juntos. Cuando se separaban, el ticket se imprimia a
  // nombre de un vendedor y la nota se guardaba con otro. El texto se arma
  // igual que el value de las opciones del combo (sin trim), o el select se
  // queda sin nada seleccionado.
  const aplicaVendedor = (colaborador) => {
    if (!colaborador) return;
    const nombre = colaborador.nombre + " " + colaborador.apellido;
    setSelectedVendedor(colaborador._id);
    setSelectedVendedorInput([colaborador._id, nombre]);
    setSelectedColaboradorName(nombre);
  };

  // Lo que manda el combo es "<id>,<Nombre Apellido>", o "0" cuando lo
  // regresan a "Selecciona un Vendedor". Ese "0" es truthy: si se deja pasar,
  // la venta se va al servidor con colaboradores:"0" y se cae con
  // "Cast to [ObjectId] failed", sin decir que falto el vendedor. Se guarda
  // vacio y lo detiene la validacion de guardar.
  //
  // Los tres combos de Vendedor de esta pantalla (mostrador, cliente nuevo y
  // cliente existente) pasan por aqui a proposito: antes repetian el mismo
  // onChange copiado y arreglar uno dejaba los otros dos rotos.
  const eligeVendedor = (valor) => {
    vendedorTocadoRef.current = true;
    const [id, nombre] = valor.split(",");
    const vacio = !id || id === "0";
    // El texto del combo si conserva el "0", para que se siga viendo el
    // placeholder en vez de un select en blanco.
    setSelectedVendedorInput(valor);
    setSelectedVendedor(vacio ? "" : id);
    setSelectedColaboradorName(vacio ? "" : nombre);
  };

  // Arranque de mostrador: cliente CLIENTES DIVERSOS y el vendedor que ese
  // cliente trae asignado.
  //
  // Esto llegaba tarde y pisaba lo ya capturado. El combo de vendedores se
  // llena en ~0.25s, pero la lista de clientes tarda ~3s; cuando por fin
  // llegaba, volvia a poner el vendedor del cliente de mostrador encima del
  // que la cajera ya habia elegido, sin avisar, y la venta se guardaba e
  // imprimia a nombre de FOREVER TENTACION. Como la pantalla se recarga
  // despues de cada venta, esa ventana se repetia en cada nota.
  //
  // Ahora corre una sola vez y nunca encima de un vendedor elegido a mano.
  useEffect(() => {
    if (!cacheChecked) return;
    if (restoredFromCacheRef.current) return;
    if (defaultsAplicadosRef.current) return;
    if (clientes.length === 0) return;

    const selectedCliente = options.find(
      (cliente) => cliente._id === CLIENTES_DIVERSOS
    );
    if (!selectedCliente) return;
    defaultsAplicadosRef.current = true;

    setValue(selectedCliente);
    setAlertasCliente(selectedCliente.alertas);
    setListaPrecios(selectedCliente.listaPrecios);
    setSelectedColaborador(selectedCliente.vendedor?.[0]?._id || "");
    if (!vendedorTocadoRef.current) {
      aplicaVendedor(selectedCliente.vendedor?.[0]);
    }
  }, [clientes.length, cacheChecked]);

  const handleManualArticuloChange = (selectedArticulo) => {
    // Filter inventory for the selected article
    let inventario = inventarios.filter(
      (inv) => inv.idArticulo === selectedArticulo.idArticulo
    );

    let precioArt;
    if (listaPrecios == 1) {
      precioArt = selectedArticulo.lista1;
    } else if (listaPrecios == 2) {
      precioArt = selectedArticulo.lista2;
    } else if (listaPrecios == 3) {
      precioArt = selectedArticulo.lista3;
    } else if (listaPrecios == 4) {
      precioArt = selectedArticulo.lista4;
    }

    // Get unique tallas from inventory
    let tallas = inventario.reduce((acc, curr) => {
      if (!acc.includes(curr.talla)) {
        acc.push(curr.talla);
      }
      return acc;
    }, []);

    // Get unique colores from inventory
    let colores = inventario.reduce((acc, curr) => {
      if (!acc.includes(curr.color)) {
        acc.push(curr.color);
      }
      return acc;
    }, []);

    // Filter selectedArticulo.colores to only include colors present in inventory
    let coloresRed = selectedArticulo.colores.filter((c) =>
      colores.includes(c.name)
    );

    // Filter selectedArticulo.tallas to only include sizes present in inventory
    let tallasRed = selectedArticulo.tallas.filter((t) =>
      tallas.includes(t.name)
    );

    if (selectedArticulo) {
      setManualInput({
        articulos: selectedArticulo.idArticulo,
        articulosNombre: selectedArticulo.codigo + " " + selectedArticulo.nombre,
        colores: coloresRed,
        precio: precioArt,
        idProporcion: "",
        tallas: tallasRed,
        idColor: "",
        idTalla: "",
        cantidad: 0,
      });
      jalaFoto(selectedArticulo.idArticulo, selectedArticulo.urlFoto);
    }
  };
  const handleManualInputChange = (event) => {
    const { name, value } = event.target;

    setManualInput((prev) => {
      const updatedInput = {
        ...prev,
        [name]: value,
      };

      // If changing talla, update tallaNombre
      if (name === "idTalla") {
        const selectedTalla = prev.tallas.find((t) => t._id === value);
        updatedInput.tallaNombre = selectedTalla ? selectedTalla.name : "";
      }

      // Calculate total whenever cantidad changes
      if (name === "cantidad") {
        const selectedColor = manualInput.colores.find(
          (c) => c._id === manualInput.idColor
        );
        const selectedTalla = manualInput.tallas.find(
          (t) => t._id === manualInput.idTalla
        );
        updatedInput.cantidad = parseFloat(value);

        if (selectedColor && selectedTalla) {
          const inventario = inventarios.find(
            (inv) =>
              inv.idArticulo === manualInput.articulos &&
              inv.color === selectedColor.name &&
              inv.talla === selectedTalla.name
          );

          if (!inventario || inventario.cantidad <= 0) {
            Swal.fire({
              icon: "error",
              title: "Sin existencia",
              text: "No hay existencia disponible para esta talla y color.",
              showConfirmButton: false,
            });
            updatedInput.cantidad = 0;
          } else {
            updatedInput.idProporcion = inventario.idProporcion;
            if (updatedInput.cantidad > inventario.cantidad) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: `La cantidad excede tu inventario de ${inventario.cantidad}`,
                showConfirmButton: false,
              });
              updatedInput.cantidad = inventario.cantidad;
            }
          }
        }
      }

      return updatedInput;
    });
  };

  const handleManualAdd = async () => {
    if (
      !manualInput.articulosNombre ||
      !manualInput.idColor ||
      !manualInput.idTalla ||
      !manualInput.cantidad
    ) {
      return;
    }

    const selectedColor = manualInput.colores.find(
      (c) => c._id === manualInput.idColor
    );
    const selectedTalla = manualInput.tallas.find(
      (t) => t._id === manualInput.idTalla
    );

    const inventario = inventarios.find(
      (inv) =>
        inv.idArticulo === manualInput.articulos &&
        inv.color === selectedColor.name &&
        inv.talla === selectedTalla.name
    );

    if (!inventario || inventario.cantidad <= 0) {
      Swal.fire({
        icon: "error",
        title: "Sin existencia",
        text: "No hay existencia disponible para este artículo.",
        showConfirmButton: false,
      });
      return;
    }

    const cantidadFinal = Math.min(inventario.cantidad, manualInput.cantidad);

    if (inventario) {
      const avaible = inputFields.find(
        (i) => i.idArticuloProporcion === inventario.idArticuloProporcion
      );

      if (avaible) {
        const nuevaCantidad = avaible.cantidad + manualInput.cantidad;
        if (nuevaCantidad > inventario.cantidad) {
          Swal.fire({
            icon: "error",
            title: "Stock insuficiente",
            text: `Solo hay ${inventario.cantidad} disponibles y ya tienes ${avaible.cantidad} agregados.`,
            showConfirmButton: false,
          });
          return;
        }
        // Create new array with updated object
        const updatedFields = inputFields.map((field) => {
          if (field.idArticuloProporcion === inventario.idArticuloProporcion) {
            return {
              ...field,
              cantidad: field.cantidad + manualInput.cantidad,
              total: (field.cantidad + manualInput.cantidad) * field.precio,
            };
          }
          return field;
        });

        setInputFields(updatedFields);
        ActualizaTotales(updatedFields);
        setManualInput((prev) => ({
          ...prev,
          idColor: "",
          articulos: "",
          articulosNombre: "",
          cantidad: 0,
          idTalla: "",
          tallaNombre: "",
          total: 0,
          idProporcion: "",
        }));

        return null;
      }

      const newField = {
        id: uuidv4(),
        articulos: manualInput.articulos,
        precio: manualInput.precio,
        idInv: inventario._id,
        cantInv: inventario.cantidad,
        articulosNombre: inventario.eanProporcion + " " + manualInput.articulosNombre + " " + inventario.eanProporcion,
        idArticuloProporcion: inventario.idArticuloProporcion,

        precioEsp: inventario.precioEsp,
        venta: inventario.venta,
        costoUnitario: inventario.costoUnitario,
        precioOriginal: inventario.venta,
        cantidad: cantidadFinal,
        total: cantidadFinal * manualInput.precio,

        idTalla: manualInput.idTalla,
        tallaNombre: selectedTalla ? selectedTalla.name : "",
        idColor: manualInput.idColor,
        colorNombre: selectedColor ? selectedColor.name : "",
        colores: manualInput.colores,
        tallas: manualInput.tallas,
        cajas: 0,
      };

      setInputFields((prev) => [...prev, newField]);

      // Reset only specific fields after adding
      setManualInput((prev) => ({
        ...prev,
        idColor: "",
        articulos: "",
        articulosNombre: "",
        cantidad: 0,
        idTalla: "",
        tallaNombre: "",
        total: 0,
        precio: 0,
        idProporcion: "",
      }));
    }
  };

  const handleCreateNewArticuloTalla = async (idArticulo, idColor, tallaNombre, cantidad, precio, colores) => {
    if (!cantidad || parseFloat(cantidad) <= 0) return;

    // Buscar la talla completa en el array de tallas
    const tallaCompleta = tallas.find(t => t.name === tallaNombre);
    if (!tallaCompleta) return;

    // Buscar el color completo en el array de colores del artículo
    const colorCompleto = colores.find(c => c._id === idColor);
    if (!colorCompleto) return;

    // Find the inventory item for this specific combination
    const inventario = inventarios.find(
      (inv) =>
        inv.idArticulo === idArticulo &&
        inv.color === colorCompleto.name &&
        inv.talla === tallaNombre
    );

    if (!inventario) {
      return;
    }

    if (inventario.cantidad < parseFloat(cantidad)) {
      return;
    }

    // Check if this exact combination already exists
    const existingItem = inputFields.find(
      (item) => item.idArticuloProporcion === inventario.idArticuloProporcion
    );

    if (existingItem) {
      const newQuantity = existingItem.cantidad + parseFloat(cantidad);
      if (newQuantity > inventario.cantidad) {
        Swal.fire({
          icon: "error",
          title: "Stock insuficiente",
          text: `Solo hay ${inventario.cantidad} disponibles y ya tienes ${existingItem.cantidad} agregados.`,
          showConfirmButton: false,
        });
        return;
      }
      // Update existing item quantity
      const updatedFields = inputFields.map((field) => {
        if (field.idArticuloProporcion === inventario.idArticuloProporcion) {
          return {
            ...field,
            cantidad: newQuantity,
            total: newQuantity * field.precio,
          };
        }
        return field;
      });
      setInputFields(updatedFields);
      ActualizaTotales(updatedFields);
      return;
    }

    // Buscar el artículo completo para obtener el código y nombre
    const articuloCompleto = articulosUnicos.find(a => a.idArticulo === idArticulo);
    if (!articuloCompleto) return;

    const newField = {
      id: uuidv4(),
      articulos: idArticulo,
      precio: precio,
      idInv: inventario._id,
      cantInv: inventario.cantidad,
      articulosNombre: `${articuloCompleto.codigo} ${articuloCompleto.nombre}`,
      precioEsp: inventario.precioEsp,
      venta: inventario.venta,
      costoUnitario: inventario.costoUnitario,
      precioOriginal: inventario.venta,
      cantidad: parseFloat(cantidad),
      total: parseFloat(cantidad) * precio,
      idTalla: tallaCompleta._id,
      tallaNombre: tallaNombre,
      idColor: idColor,
      colorNombre: colorCompleto.name,
      colores: colores,
      tallas: articuloCompleto.tallas || [],
      cajas: 0,
      idArticuloProporcion: inventario.idArticuloProporcion,
    };

    const newFields = [...inputFields, newField];
    setInputFields(newFields);
    ActualizaTotales(newFields);
  };

  async function buscarArticuloSingular(id, event) {
    // El campo es NO controlado: el navegador acumula los caracteres del escáner
    // sin que React reescriba el value (eso corrompía las lecturas rápidas del RFID).
    const inputEl = event.target;
    const raw = (inputEl.value || "").trim();

    // El lector RFID entrega un EPC SGTIN-96 (24 hex). Lo convertimos a EAN-13.
    const epcDecoded = epcToEAN13(raw);
    const scanned = epcDecoded || raw;
    const scannedUpper = scanned.toUpperCase();

    // Mismo tag fisico ya contado: no sumar otra pieza.
    const esTagRFID = !!epcDecoded;
    // El lector puede mandar el EPC (24 hex) o su EAN-13 ya decodificado (13
    // digitos). Ambos son lectura de etiqueta: avisos no bloqueantes y contador.
    // Solo el EPC trae numero de serie, asi que solo con EPC se detecta un tag repetido.
    const esLecturaEtiqueta = esTagRFID || validateEAN13(scanned);
    const epc = raw.replace(/\s+/g, "").toUpperCase();
    if (esTagRFID && epcLeidosRef.current.has(epc)) {
      inputEl.value = "";
      setRfidStats((st) => ({ ...st, repetidas: st.repetidas + 1 }));
      return;
    }
    // idArticuloProporcion del renglon al que se sumo la pieza (null = no se sumo)
    let agregado = null;

    let encontrado = false;
    try {
      inventarios.map((a) => {
        // Coincide con el QR/EAN de la proporción o con el RFID (EAN-13) de la etiqueta
        if (
          (a.eanProporcion && a.eanProporcion.toUpperCase() === scannedUpper) ||
          (a.rfid && a.rfid === scanned)
        ) {
          encontrado = true;
          let idArticulo = a.idArticulo;
          const etiqueta = a.eanProporcion || a.rfid || "";
          let articulosNombre = etiqueta + " " + a.codigo + " " + a.nombre + " " + etiqueta;
          let colores = a.colores;
          let tallas = a.tallas;
          let cantInv = parseFloat(a.cantidad);
          let idInv = a._id;
          let idColor = a.idColor;
          let idTalla = a.idTalla;

          if (cantInv <= 0) {
            alertaEscaneo(esLecturaEtiqueta, {
              icon: "error",
              title: "Sin existencia",
              text: "No hay existencia disponible para este artículo.",
              showConfirmButton: false,
            });
            return null;
          }

          let precio;
          if (listaPrecios == 1) {
            precio = a.lista1;
          } else if (listaPrecios == 2) {
            precio = a.lista2;
          } else if (listaPrecios == 3) {
            precio = a.lista3;
          } else if (listaPrecios == 4) {
            precio = a.lista4;
          }

          const avaible = inputFields.find(
            (i) => i.idArticuloProporcion === a.idArticuloProporcion
          );

          if (avaible) {
            if (avaible.cantidad + 1 > cantInv) {
              alertaEscaneo(esLecturaEtiqueta, {
                icon: "error",
                title: "Stock insuficiente",
                text: `Solo hay ${cantInv} disponibles y ya tienes ${avaible.cantidad} agregados.`,
                showConfirmButton: false,
              });
              return null;
            }
            // Create new array with updated object
            const updatedFields = inputFields.map((field) => {
              if (field.idArticuloProporcion === a.idArticuloProporcion) {
                return {
                  ...field,
                  cantidad: field.cantidad + 1,
                  total: (field.cantidad + 1) * field.precio,
                };
              }
              return field;
            });

            agregado = a.idArticuloProporcion;
            setInputFields(updatedFields);
            ActualizaTotales(updatedFields);
            return null;
          }

          const newField = {
            id: uuidv4(),
            articulos: idArticulo,
            precio: precio,
            idInv: idInv,
            cantInv: cantInv,
            articulosNombre: articulosNombre,

            precioEsp: a.precioEsp,
            venta: a.venta,
            costoUnitario: a.costoUnitario,
            precioOriginal: a.venta,
            cantidad: 1,
            total: precio,

            idTalla: idTalla,
            tallaNombre: a.talla,
            idColor: idColor,
            colorNombre: a.color,
            colores: a.colores,
            tallas: a.tallas,
            cajas: 0,
            idArticuloProporcion: a.idArticuloProporcion,
          };
          jalaFoto(a.idArticulo, a.urlFoto);

          agregado = a.idArticuloProporcion;
          setInputFields((prev) => [...prev, newField]);

          // Reset only specific fields after adding
          setManualInput((prev) => ({
            ...prev,
            idColor: "",
            articulos: "",
            articulosNombre: "",
            cantidad: 0,
            idTalla: "",
            tallaNombre: "",
            total: 0,
            precio: 0,
            idProporcion: "",
          }));
        }
        return null;
      });

      if (encontrado) {
        // Limpia el campo para el siguiente escaneo
        inputEl.value = "";
        if (esTagRFID && agregado) epcLeidosRef.current.set(epc, agregado);
        if (esLecturaEtiqueta && agregado) {
          setRfidStats((st) => ({ ...st, leidas: st.leidas + 1 }));
        }
      } else {
        // Código completo (EAN-13 o EPC RFID) escaneado pero sin existencia en la tienda
        const codigoCompleto =
          validateEAN13(scanned) ||
          /^[0-9A-F]{24}$/i.test(raw.replace(/\s+/g, ""));
        if (codigoCompleto) {
          inputEl.value = "";
          if (esLecturaEtiqueta) {
            setRfidStats((st) => ({ ...st, noEncontradas: st.noEncontradas + 1 }));
          }
          alertaEscaneo(esLecturaEtiqueta, {
            icon: "error",
            title: "Artículo no encontrado",
            text: "El código escaneado no tiene existencia en esta tienda.",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            if (rfidScanRef.current) rfidScanRef.current.focus();
          });
        }
      }
    } catch (error) {
      console.log("error", error);
      Swal.fire({
        icon: "error",
        title: "Artículo no encontrado",
        text: "No se encontró ningún artículo con el código proporcionado",
      });
    }
  }

  const saveVenta = async (event) => {
    event.preventDefault();
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: "¿Deseas guardar esta venta?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, guardar",
      cancelButtonText: "Cancelar",
    });
    if (!result.isConfirmed) return;
    if (submittingRef.current) return;
    submittingRef.current = true;
    setValidaBoton(false);

    // Calculate the total paid and the balance
    const totalPaid =
      parseFloat(efectivo) + parseFloat(tdc) + parseFloat(transfer) + parseFloat(deposito) + parseFloat(cheque) + parseFloat(comisionTDC) + parseFloat(comisionFlete);
    const changeAmount = totalPaid - total_general;

    // Validaciones iniciales
    if (changeAmount > 0 && efectivo <= 0) {
      showError("No hay efectivo para dar cambio. Ajusta los montos de pago.");
      return;
    }

    if (!caja) {
      showError("Debes seleccionar una Caja antes de guardar la venta");
      return;
    }

    // Va aqui y no dentro de cada rama: la venta con cliente existente (que
    // son casi todas) no validaba el vendedor en ningun lado, y sin el la
    // nota se cae en el servidor con un error que no dice que falta.
    if (!selectedVendedor || selectedVendedor === "0") {
      showError("Debes seleccionar el Vendedor antes de guardar la venta");
      return;
    }

    if (tdc > 0 && terminal === "") {
      showError("Debes Capturar la Terminal para el pago con TDC");
      return;
    }

    if (transfer > 0 && destino === "") {
      showError("Debes Capturar el Destino para la Transferencia");
      return;
    }

    if (deposito > 0 && destinoDeposito === "") {
      showError("Debes Capturar la Cuenta de Depósito");
      return;
    }

    if (cheque > 0 && destinoCheque === "") {
      showError("Debes Capturar el Banco Destino del Cheque");
      return;
    }

    if (cheque > 0 && numeroCheque.trim() === "") {
      showError("Debes Capturar el Número de Cheque");
      return;
    }

    if (condPago === "Contado" && (total_general - totalPaid) > 0.01) {
      showError("El Pago no coincide con el Total");
      return;
    }

    // Validación de cantidad y precios
    const cantidadIF = inputFields.length;
    const cantidadCapturada = inputFields.filter((a) => a.cantidad > 0).length;
    const preciosValidos =
      cambiarPrecio ||
      user.precio_menor ||
      inputFields.every((a) => a.precio >= a.precioOriginal - 51);

    if (cantidadCapturada !== cantidadIF) {
      showError("Existen Productos sin capturar la cantidad");
      return;
    }

    if (!preciosValidos) {
      showError("No puedes vender $50 menos del precio original");
      return;
    }

    // Validar stock actual antes de procesar (puede haber cambiado desde el cache)
    const stockValido = await validarStockActual();
    if (!stockValido) return;

    // Handle scenarios where customer overpaid and there's cash to give change
    if (changeAmount > 0) {
      // Calculate the adjusted efectivo value
      const newEfectivo = efectivo - changeAmount;

      // Show the amount of change and require confirmation before proceeding
      Swal.fire({
        icon: "warning",
        title: "El cambio a entregar al cliente es",
        text: `$${changeAmount.toFixed(2)}`,
        confirmButtonText: "Confirmar",
        showCancelButton: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          // Continue with the sale processing after confirmation, using newEfectivo
          try {
            toggleProgreso();

            // Use the adjusted efectivo value
            const efeGuarda = parseFloat(newEfectivo);
            const prefijo = fiscal === "Si" ? "F" : String(user.areaNumero || "N");
            const totalPedido = inputFields.length;

            // Si no se está creando un nuevo cliente
            if (!vistaCliente) {
              await procesarVentaExistente(efeGuarda, prefijo, totalPedido);
            }
            // Si se está creando un nuevo cliente
            else {
              if (!validarDatosCliente()) {
                showError("Por favor revisa el formulario, faltan Datos");
                return;
              }
              await procesarVentaNuevoCliente(efeGuarda, prefijo, totalPedido);
            }
          } catch (error) {
            showError("Error al procesar la venta", error);
            console.log(error);
          }
        }
      });
    } else {
      // No change needed, proceed directly with original calculation
      try {
        toggleProgreso();

        // Use the original efectivo + saldo calculation
        const efeGuarda = parseFloat(efectivo) + parseFloat(saldo);
        const prefijo = fiscal === "Si" ? "F" : String(user.areaNumero || "N");
        const totalPedido = inputFields.length;

        // Si no se está creando un nuevo cliente
        if (!vistaCliente) {
          await procesarVentaExistente(efeGuarda, prefijo, totalPedido);
        }
        // Si se está creando un nuevo cliente
        else {
          if (!validarDatosCliente()) {
            showError("Por favor revisa el formulario, faltan Datos");
            return;
          }
          await procesarVentaNuevoCliente(efeGuarda, prefijo, totalPedido);
        }
      } catch (error) {
        showError("Error al procesar la venta", error);
        console.log(error);
      }
    }
  };

  // Función auxiliar para mostrar errores
  const showError = (message, error = null) => {
    let footerHtml = "";
    if (error && error.response && error.response.data) {
      const data = error.response.data;
      const mainMsg = data.error || data.message || JSON.stringify(data);
      const validationList = Array.isArray(data.validationErrors) && data.validationErrors.length > 0
        ? `<ul style="text-align:left;margin:4px 0 0 0;padding-left:16px;">${data.validationErrors.map(e => `<li>${e}</li>`).join("")}</ul>`
        : "";
      const detailsMsg = data.details && data.details !== mainMsg
        ? `<p style="margin-top:6px;font-size:11px;color:#888;word-break:break-word;text-align:left;">${data.details}</p>`
        : "";
      footerHtml = `<p style="color:#d33;word-break:break-word;">${mainMsg}</p>${validationList}${detailsMsg}`;
    } else if (error && error.message) {
      footerHtml = `<p style="color:#d33;">${error.message}</p>`;
    }
    setModalProgreso(false);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: message,
      footer: footerHtml || undefined,
      showConfirmButton: true,
    });
    submittingRef.current = false;
    setValidaBoton(true);
  };

  // Validar stock actual contra el servidor antes de guardar
  const validarStockActual = async () => {
    try {
      const res = await axios.get(
        `${URL_INVENTARIOS}VentaTienda/${user.areas}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      const inventarioActual = res.data;
      const erroresStock = [];

      for (const field of inputFields) {
        if (!field.idInv || field.cantidad <= 0) continue;

        const inv = inventarioActual.find((i) => i._id === field.idInv);
        if (!inv) {
          erroresStock.push(
            `"${field.articulosNombre}" (${field.tallaNombre || ""} ${field.colorNombre || ""}) ya no existe en inventario`
          );
        } else if (inv.cantidad < field.cantidad) {
          erroresStock.push(
            `"${field.articulosNombre}" (${field.tallaNombre || ""} ${field.colorNombre || ""}): solo hay ${inv.cantidad} disponible(s), necesitas ${field.cantidad}`
          );
        }
      }

      if (erroresStock.length > 0) {
        Swal.fire({
          icon: "error",
          title: "Stock Insuficiente",
          html: `<p>Los siguientes productos no tienen stock suficiente:</p>
            <ul style="text-align:left; margin-top:10px;">
              ${erroresStock.map((e) => `<li style="margin-bottom:5px;">${e}</li>`).join("")}
            </ul>
            <p style="margin-top:10px;">Por favor ajusta las cantidades antes de guardar.</p>`,
          showConfirmButton: true,
        });
        submittingRef.current = false;
        setValidaBoton(true);
        return false;
      }

      return true;
    } catch (err) {
      showError("No se pudo verificar el stock actual. Intenta de nuevo.");
      return false;
    }
  };

  // Función para validar datos del cliente
  const validarDatosCliente = () => {
    return (
      selectedGrupo !== "" &&
      selectedDepartamento !== "" &&
      selectedPaqueteria !== "" &&
      selectedAreaCliente !== "" &&
      selectedVendedor !== ""
    );
  };

  // Función para procesar venta con cliente existente (atomic transaction)
  const procesarVentaExistente = async (efeGuarda, prefijo, totalPedido) => {
    try {
      // Preparar datos de artículos
      const articlesData = inputFields
        .filter(
          (articulo) => articulo.articulos !== "" && articulo.cantidad > 0
        )
        .map((articulo) => ({
          articulos: articulo.articulos,
          cantidad: parseFloat(articulo.cantidad),
          precio: parseFloat(articulo.precio),
          total: parseFloat(articulo.total),
          inventarios: articulo.idInv,
          costoUnitario: articulo.costoUnitario,
          colores: articulo.idColor,
          tallas: articulo.idTalla,
          articulosProporcion: articulo.idArticuloProporcion,
          colaboradores: selectedVendedor,
        }));

      // Validate all articles have valid inventory reference
      const invalidArticles = articlesData.filter((a) => !a.inventarios);
      if (invalidArticles.length > 0) {
        throw new Error(
          `${invalidArticles.length} artículo(s) sin referencia de inventario válida`
        );
      }

      // Preparar datos de pago si es al contado
      let paymentData = null;
      if (condPago === "Contado") {
        paymentData = {
          total: total_general,
          areas: user.areas,
          efectivo: efeGuarda,
          tdc,
          transfer,
          deposito,
          cheque,
          destinoCheque,
          fechaCheque,
          numeroCheque,
          destino,
          destinoDeposito,
          fechaDeposito,
          fechaTransfer,
          terminal,
          cortesia: 0,
          codigoAgrupado,
        };
      }

      const completeVentaData = {
        fecha,
        caja: caja || user.cajaId || undefined,
        clientes: value._id,
        colaboradores: selectedVendedor,
        user: user.id,
        total_general: parseFloat(total_general.toFixed(2)),
        observaciones,
        total_cantidad,
        paqueterias: idPaqueteria,
        areas: user.areas,
        comisionTDC,
        comisionFlete,
        subTotal: parseFloat(subTotal.toFixed(2)),
        iva: parseFloat(iva.toFixed(2)),
        impuestos: selectedImpuesto,
        cond_pago: condPago,
        fiscal,
        saldo: parseFloat(saldo.toFixed(2)),
        cortesia: 0,
        prefijo,
        entregado: "Si",
        descuento: descuentoTipo === "%" ? parseFloat(descuento) : parseFloat(subTotal) > 0 ? parseFloat(((getDescuentoMonto(parseFloat(subTotal), descuentoTipo, descuento, parseFloat(selectedImpuesto)) / parseFloat(subTotal)) * 100).toFixed(4)) : 0,
        descuentoTipo,
        descuentoNumero: parseFloat(getDescuentoMonto(parseFloat(subTotal), descuentoTipo, descuento, parseFloat(selectedImpuesto)).toFixed(2)),
        areaSurtido: selectedArea,
        createClient: false,
        articles: articlesData,
        paymentData: paymentData,
      };

      const ventaResponse = await axios.post(
        `${URL_VENTAS_TIENDAS}Complete`,
        completeVentaData,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      await finalizarVenta(ventaResponse.data, prefijo, value._id, efeGuarda);
    } catch (error) {
      throw error;
    }
  };

  // Función para procesar venta con nuevo cliente (atomic transaction)
  const procesarVentaNuevoCliente = async (efeGuarda, prefijo, totalPedido) => {
    try {
      const clienteData = {
        nombre_comercial,
        razon_social,
        RFC,
        calle,
        numero_ext,
        numero_int,
        delegacion,
        estado,
        pais,
        cp,
        colonia,
        ciudad,
        telefono,
        email,
        grupos: selectedGrupo,
        departamentosClientes: selectedDepartamento,
        vendedor: selectedVendedor,
        observaciones: observacionesCliente,
        ultimo_pago: "2000-01-01",
        forma_pago,
        areas: selectedAreaCliente,
        plazo,
        regFiscal,
        usoCFDI,
        formaPagoSAT,
        condicionesPagoSAT,
        metodoPagoSAT,
        cargosk: 0,
        abonosk: 0,
        saldok: 0,
        fiscal: "No",
        cargos: 0,
        abonos: 0,
        saldo: 0,
        descuento: descuentoCliente,
        paqueterias: selectedPaqueteria,
        alertas: "Si",
        listaPrecios: 1,
      };

      // Preparar datos de artículos
      const articlesData = inputFields
        .filter(
          (articulo) => articulo.articulos !== "" && articulo.cantidad > 0
        )
        .map((articulo) => ({
          articulos: articulo.articulos,
          cantidad: parseFloat(articulo.cantidad),
          precio: parseFloat(articulo.precio),
          total: parseFloat(articulo.total),
          inventarios: articulo.idInv,
          costoUnitario: articulo.costoUnitario,
          colores: articulo.idColor,
          tallas: articulo.idTalla,
          articulosProporcion: articulo.idArticuloProporcion,
          colaboradores: selectedVendedor,
        }));

      // Validate all articles have valid inventory reference
      const invalidArticles = articlesData.filter((a) => !a.inventarios);
      if (invalidArticles.length > 0) {
        throw new Error(
          `${invalidArticles.length} artículo(s) sin referencia de inventario válida`
        );
      }

      // Preparar datos de pago si es al contado
      let paymentData = null;
      if (condPago === "Contado") {
        paymentData = {
          total: total_general,
          areas: user.areas,
          efectivo: efeGuarda,
          tdc,
          transfer,
          deposito,
          cheque,
          destinoCheque,
          fechaCheque,
          numeroCheque,
          destino,
          destinoDeposito,
          fechaDeposito,
          fechaTransfer,
          terminal,
          cortesia: 0,
          codigoAgrupado,
        };
      }

      const completeVentaData = {
        fecha,
        caja: caja || user.cajaId || undefined,
        colaboradores: selectedVendedor,
        user: user.id,
        total_general: parseFloat(total_general.toFixed(2)),
        observaciones,
        total_cantidad,
        paqueterias: idPaqueteria,
        areas: user.areas,
        comisionTDC,
        comisionFlete,
        subTotal: parseFloat(subTotal.toFixed(2)),
        iva: parseFloat(iva.toFixed(2)),
        impuestos: selectedImpuesto,
        cond_pago: condPago,
        fiscal,
        saldo: parseFloat(saldo.toFixed(2)),
        cortesia: 0,
        prefijo,
        entregado: "Si",
        descuento: descuentoTipo === "%" ? parseFloat(descuento) : parseFloat(subTotal) > 0 ? parseFloat(((getDescuentoMonto(parseFloat(subTotal), descuentoTipo, descuento, parseFloat(selectedImpuesto)) / parseFloat(subTotal)) * 100).toFixed(4)) : 0,
        descuentoTipo,
        descuentoNumero: parseFloat(getDescuentoMonto(parseFloat(subTotal), descuentoTipo, descuento, parseFloat(selectedImpuesto)).toFixed(2)),
        areaSurtido: selectedArea,
        createClient: true,
        clientData: clienteData,
        articles: articlesData,
        paymentData: paymentData,
      };

      const ventaResponse = await axios.post(
        `${URL_VENTAS_TIENDAS}Complete`,
        completeVentaData,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      // For new clients, get the client ID from the returned venta
      await finalizarVenta(
        ventaResponse.data,
        prefijo,
        ventaResponse.data.clientes,
        efeGuarda
      );
    } catch (error) {
      throw error;
    }
  };

  // Función para finalizar la venta
  const finalizarVenta = async (ventaData, prefijo, clienteId, efeGuarda) => {
    // ventaData is the venta document returned directly by createComplete
    const actualVenta = ventaData;

    await axios.post(
      URL_LOGS,
      {
        tipo: "Crear Venta de Tienda",
        detalle: JSON.stringify([
          { ventaId: actualVenta._id },
          { consecutivo: `${actualVenta.prefijo || ""}-${actualVenta.consecutivo}` },
          { caja: caja || user.cajaId || null },
          { area: user.areas },
          { areaNombre: user.areaName },
          { total: total_general },
          { clienteId },
          { cond_pago: condPago },
          { cajeroId: user.id },
          { cajeroNombre: `${user.nombre} ${user.apellido}` },
        ]),
        user: user.id,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    setModalProgreso(false);
    localStorage.removeItem(ventaCacheKey);

    // Imprime SIEMPRE el ticket y, aparte, pregunta si tambien se envia por WhatsApp.
    const ventaIdWA = actualVenta._id || actualVenta.id;
    let ticket;
    if (ventaIdWA) {
      ticket = await PDFOC(ventaIdWA, actualVenta.consecutivo, prefijo, efeGuarda);
    }

    // Solo preguntamos por WhatsApp cuando el cliente tiene un telefono valido.
    const telTicket = ticket && ticket.tel ? String(ticket.tel).trim() : "";
    if (ticket && telTicket !== "" && telTicket !== "1") {
      const envioWA = await Swal.fire({
        title: "¿Enviar también el ticket por WhatsApp?",
        text: `Se enviará al número ${telTicket}`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#25D366",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, enviar",
        cancelButtonText: "No",
      });
      if (envioWA.isConfirmed) {
        await enviarTicketWhatsApp(
          ticket.att,
          ticket.tel,
          ticket.nom,
          actualVenta.consecutivo,
          prefijo
        );
      }
    }

    // Verificar si hay pago con TDC para sugerir facturación
    // if (tdc > 0) {
    Swal.fire({
      title: "¿Deseas facturar esta venta?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, facturar",
      cancelButtonText: "No por ahora",
    }).then((result) => {
      if (result.isConfirmed) {
        // Redirige al componente de factura con el ID de la venta
        window.location.href = `/FacturasTiendasCreate/${actualVenta._id}`;
      } else {
        // Si no se confirma la facturación, mostrar mensaje de éxito y recargar
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Creado con éxito",
          text: "Por favor no refresques ni cierres la ventana",
          showConfirmButton: false,
        });

        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    });
    // } else {
    //   // Si no hay pago con TDC, mostrar mensaje de éxito y recargar normalmente
    //   Swal.fire({
    //     position: "center",
    //     icon: "success",
    //     title: "Creado con éxito",
    //     text: "Por favor no refresques ni cierres la ventana",
    //     showConfirmButton: false,
    //   });

    //   setTimeout(() => {
    //     window.location.reload();
    //   }, 3000);
    // }
  };

  async function PDFOC(idPDFOC, consecutivo, prefijo, efeGuarda) {
    let cambio = parseFloat(efectivo) - parseFloat(efeGuarda);
    let LA = inputFields.length * 1.5;
    let largoTotal = LA + 4 + 18;

    let agrupado = inputFields.reduce(function (groups, item) {
      const val = item["articulos"];
      groups[val] = groups[val] || {
        articulos: item.articulos,
        articulosNombre: item.articulosNombre,
        cantidad: 0,
        total: 0,
        cajas: 0,
        precio: item.precio,
        lineas: [],
      };
      groups[val].cantidad += item.cantidad;
      groups[val].total += item.total;
      groups[val].cajas += item.cajas;
      // Consolida por color+talla: si la misma talla/color ya existe en el
      // desglose, suma su cantidad y total en lugar de crear otro renglón.
      const tallaNombre = item.tallaNombre || "";
      const colorNombre = item.colorNombre || "";
      const lineaExistente = groups[val].lineas.find(
        (l) => l.tallaNombre === tallaNombre && l.colorNombre === colorNombre
      );
      if (lineaExistente) {
        lineaExistente.cantidad += item.cantidad;
        lineaExistente.total += item.total;
      } else {
        groups[val].lineas.push({
          tallaNombre,
          colorNombre,
          cantidad: item.cantidad,
          precio: item.precio,
          total: item.total,
        });
      }
      return groups;
    }, []);

    let dataAgrupado = Object.values(agrupado);

    const data = dataAgrupado
      .sort((a, b) => (a.articulosNombre > b.articulosNombre ? 1 : -1))
      .flatMap((a) => [
        [{ content: a.articulosNombre, colSpan: 3, styles: { fontStyle: "bold", halign: "left", cellPadding: { top: 0.1, bottom: 0, left: 0.1, right: 0.1 } } }],
        ...a.lineas.map((l) => [
          { content: `   ${new Intl.NumberFormat("en-US").format(l.cantidad)} x  ${l.colorNombre} / ${l.tallaNombre}`, colSpan: 3, styles: { halign: "left", fontStyle: "bold", fontSize: 8, cellPadding: { top: 0.05, bottom: 0.05, left: 0.2, right: 0.1 } } },
        ]),
        [
          { content: `Cant: ${new Intl.NumberFormat("en-US").format(a.cantidad)}`, styles: { halign: "left", cellPadding: { top: 0, bottom: 0.1, left: 0.1, right: 0.1 } } },
          { content: `Precio: ${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.precio)}`, styles: { halign: "left", cellPadding: { top: 0, bottom: 0.1, left: 0.1, right: 0.1 } } },
          { content: `Total: ${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.total)}`, styles: { halign: "right", cellPadding: { top: 0, bottom: 0.1, left: 0.1, right: 0.1 } } },
        ],
      ]);
    let TK = dataAgrupado.reduce((sum, a) => sum + (parseFloat(a.cantidad) || 0), 0);
    let TC = dataAgrupado.reduce((sum, a) => sum + (parseFloat(a.cajas) || 0), 0);
    let TG = dataAgrupado.reduce((sum, a) => sum + (parseFloat(a.total) || 0), 0);

    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });

    const doc = new jsPDF("p", "cm", [8, largoTotal], true);
    var base64 = await qrcode.toDataURL(idPDFOC); // Corrección: await para qrcode.toDataURL
    var img3 = new Image();
    img3.src = base64;

    var img2 = new Image();
    img2.src = "logoInstitucion.png";

    doc.addImage(img2, "png", 5, 1, 2, 2);

    doc.setFontSize(6).setFont(undefined, "bold");
    doc.text(`${import.meta.env.VITE_NOMBRE_INSTITUCION}`, 0.3, 1);
    doc.text(`Sucursal: ${user.areaName}`, 0.3, 1.3);
    doc.text(`Direccion:${user.areaDireccion}`, 0.3, 1.6);
    doc.text(`Atencion al Cliente: ${user.areaTelefono}`, 0.3, 1.9);

    doc.text(`Fecha: ${fecha} ${hora}`, 0.3, 2.5);
    doc.text(
      `Nota: ${prefijo}-${consecutivo} / Almacen: ${selectedAreaName}`,
      0.3,
      2.8
    );

    let tel;
    let nom;

    if (!vistaCliente) {
      doc.text(`Cliente: ${value.nombre_comercial}`, 0.3, 3.4);
      tel = value.telefono;
      nom = value.nombre_comercial;
    } else {
      doc.text(`Cliente: ${nombre_comercial}`, 0.3, 3.4);
      tel = telefono;
      nom = nombre_comercial;
    }

    doc.text(`Vendedor: ${selectedColaboradorName}`, 0.3, 3.7);
    doc.text(`Cajero: ${user.nombre} ${user.apellido}`, 0.3, 4.0);

    doc.autoTable({
      head: [[{ content: "Articulos", colSpan: 3, styles: { halign: "left" } }]],
      body: dataPDFLimpia,
      styles: { fontSize: 8, overflow: "linebreak" },
      startY: 4.3,
      theme: "plain",
      margin: { left: 0.3, right: 0.3 },
      foot: [
        [{ content: "Total Cajas", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US").format(TC)],
        [{ content: "Total Piezas", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US").format(TK)],
        [{ content: "SubTotal s/IVA", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(subTotal)],
        [{ content: `Descuento ${descuentoTipo === "%" ? `${descuento}%` : new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(descuento)}`, colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(getDescuentoMonto(subTotal, descuentoTipo, descuento))],
        [{ content: "IVA (16%)", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(iva)],
        [{ content: "Comision TDC", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(comisionTDC)],
        [{ content: "Flete", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(comisionFlete)],
        [{ content: "Total", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(total_general)],
        [{ content: "Forma de Pago", colSpan: 3, styles: { halign: "left", fontStyle: "bold" } }],
        ["Efectivo", "TDC", "Transfer"],
        [
          new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(efectivo),
          new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(tdc),
          new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(transfer),
        ],
        ...(deposito > 0 ? [
          [{ content: "Depósito", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(deposito)],
        ] : []),
        ...(cheque > 0 ? [
          [{ content: "Cheque", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(cheque)],
          [{ content: `Cheque No. ${numeroCheque} - ${destinoCheque}`, colSpan: 3, styles: { halign: "left" } }],
        ] : []),
        [{ content: "Cambio", colSpan: 2, styles: { halign: "left" } }, new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(cambio)],
      ],
      showFoot: "lastPage",
      pageBreak: "auto",
      tableWidth: "auto",
    });

    if (condPago === "Credito") {
      doc.text(
        `Firma: ________________`,
        0.3,
        doc.autoTable.previous.finalY + 0.5
      );
    }

    let leyendaY = doc.autoTable.previous.finalY + (condPago === "Credito" ? 1 : 0.5);
    doc.setFontSize(7);
    doc.text(
      "CAMBIOS POR MODELO ANTES DE LOS 15 DÍAS HABIENDO EXISTENCIA.",
      doc.internal.pageSize.getWidth() / 2,
      leyendaY,
      { align: "center", maxWidth: doc.internal.pageSize.getWidth() - 0.6 }
    );

    doc.autoPrint();
    window.open(doc.output("bloburl"), "_blank");

    var att = doc.output("arraybuffer");

    // PDFOC solo arma e imprime el ticket. El envio por WhatsApp lo decide
    // quien llama (finalizarVenta); aqui devolvemos los datos para enviarlo.
    return { att, tel, nom };
  }

  // Envia por WhatsApp el PDF del ticket ya generado por PDFOC.
  function enviarTicketWhatsApp(att, tel, nom, consecutivo, prefijo) {
    let params = new URLSearchParams({
      number: tel,
      message: `Hola ${nom}, Gracias por confiar en ${import.meta.env.VITE_NOMBRE_INSTITUCION}, estamos para servirle!
      Cualquier duda estamos a tu órdenes!
      Bendiciones que tenga buena venta!`,
      fileName: `Nota-${prefijo}${consecutivo}.pdf`,
      mimetype: "application/pdf",
    });

    return axios
      .post(`${URL_WHATSAPP}SendPDFFront?${params.toString()}`, att, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "application/octet-stream",
        },
      })
      .then(() => { })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: error.response?.data?.message || error.response?.data?.error || "No se pudo enviar el PDF por WhatsApp.",
        });
        console.log(error);
      });
  }

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        idInv: "",
        cantInv: 0,
        articulos: "",
        articulosNombre: "",
        cantidad: 0,
        precio: 0,
        precioOriginal: 0,
        total: 0,
        precioEsp: "Si",
        venta: 0,
        costoUnitario: 0,
        colores: [],
        tallas: [],
        colorNombre: "",
        tallaNombre: "",
        idColor: "",
        idTalla: "",
        cajas: 0,
      },
    ]);
  };

  // Si un renglon desaparece (se elimino o se limpio la captura), sus tags se
  // liberan para que puedan volver a leerse.
  useEffect(() => {
    const vivos = new Set(inputFields.map((f) => f.idArticuloProporcion));
    epcLeidosRef.current.forEach((v, k) => {
      if (!vivos.has(v)) epcLeidosRef.current.delete(k);
    });
  }, [inputFields]);

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);

    let totalKG = values.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TK);
    let importes = values.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);

    // Los precios ya incluyen IVA, desglosar
    const taxRate1 = parseFloat(selectedImpuesto) || 0;
    let subTotalSinIva = taxRate1 > 0 ? TG / (1 + taxRate1 / 100) : TG;
    setSubTotal(subTotalSinIva);

    // Aplicar descuento sobre el subtotal
    let descuentoMonto = getDescuentoMonto(subTotalSinIva, descuentoTipo, descuento, taxRate1);
    let baseConDescuento = subTotalSinIva - descuentoMonto;
    let ivaAmount = taxRate1 > 0 ? baseConDescuento * (taxRate1 / 100) : 0;
    setIva(ivaAmount);

    let totTemp =
      baseConDescuento +
      ivaAmount +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete);

    setTotalGeneral(totTemp);
    // setSaldo(totTemp - efectivo - tdc - transfer);
  };

  const handleChangeInput = (id, event) => {
    const fieldName = event.target.name;
    const newValue = parseFloat(event.target.value);

    // Para cambios de precio, propagar a TODAS las tallas del mismo artículo+color
    const refField = fieldName === "precio" ? inputFields.find((f) => f.id === id) : null;

    const newInputFields = inputFields.map((i) => {
      const shouldUpdate =
        fieldName === "precio" && refField
          ? i.articulosNombre === refField.articulosNombre && i.idColor === refField.idColor
          : i.id === id;

      if (shouldUpdate) {
        const updatedPrecio = fieldName === "precio" ? newValue : i.precio;
        const updatedCantidad = fieldName === "cantidad" ? newValue : i.cantidad;
        return { ...i, [fieldName]: newValue, total: updatedCantidad * updatedPrecio };
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales(newInputFields);
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if (parseFloat(event.target.value) === 0) {
          Swal.fire({
            icon: "warning",
            title: "Cantidad no válida",
            text: "No puede haber tallas con cantidad 0. Si deseas eliminar esta talla usa el botón ×",
            showConfirmButton: true,
          });
          return { ...i, cantidad: 0, total: 0 };
        }
        if (i.cantInv >= event.target.value) {
          const newCantidad = parseFloat(event.target.value);
          return { ...i, cantidad: newCantidad, total: newCantidad * i.precio };
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "La cantidad excede tu inventario!",
            showConfirmButton: false,
          });
          return { ...i, cantidad: 0, total: 0 };
        }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales(newInputFields);
  };

  function BuscaArticulo(id, selectedArticulo) {
    inventarios.map((a) => {
      if (a.idArticulo === selectedArticulo.idArticulo) {
        let idArticulo = a.idArticulo;
        let precio = a.venta;
        let idInv = a._id;
        let cantInv = a.cantidad;
        let articulosNombre = a.codigo;
        let precioEsp = a.precioEsp;
        let venta = a.venta;
        let costoUnitario = a.costoUnitario;
        let precioOriginal = a.venta;
        let colores = a.colores;
        let tallas = a.tallas;

        setInputArticulos({
          id: uuidv4(),
          articulos: idArticulo,
          articulosNombre: articulosNombre,
          cajas: 0,
          precio: 0,
          colores: colores,
          tallas: tallas,
        });
      }
    });
  }

  const handleChangeInputArticulo = (
    id,
    idArticulo,
    precio,
    idInv,
    cantInv,
    articulosNombre,
    precioEsp,
    venta,
    costoUnitario,
    precioOriginal,
    colores,
    tallas
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.precio = precio;
        i.idInv = idInv;
        i.cantInv = cantInv;
        i.articulosNombre = articulosNombre;

        i.precioEsp = precioEsp;
        i.venta = venta;
        i.costoUnitario = costoUnitario;
        i.precioOriginal = precioOriginal;
        i.cantidad = 0;
        i.total = 0;

        i.colores = colores;
        i.tallas = tallas;

        i.colorNombre = "";
        i.tallaNombre = "";
        i.idColor = "";
        i.idTalla = "";
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales(newInputFields);
    // handleAddFields();
  };



  function ActualizaTotales(fields) {
    const currentFields = fields || inputFields;
    let TK = currentFields.reduce((t, c) => t + parseFloat(c.cantidad), 0);
    setTotalCantidad(TK);
    let TG = currentFields.reduce((t, c) => t + parseFloat(c.total), 0);

    // Los precios ya incluyen IVA; desglosar usando la tasa configurada
    const taxRate = parseFloat(selectedImpuesto) || 0;
    let subTotalSinIva = taxRate > 0 ? TG / (1 + taxRate / 100) : TG;
    setSubTotal(subTotalSinIva);

    let descuentoMonto = getDescuentoMonto(subTotalSinIva, descuentoTipo, descuento, taxRate);
    let baseConDescuento = subTotalSinIva - descuentoMonto;
    let ivaAmount = taxRate > 0 ? baseConDescuento * (taxRate / 100) : 0;
    setIva(ivaAmount);

    let totTemp =
      baseConDescuento +
      ivaAmount +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete);

    setTotalGeneral(parseFloat(totTemp.toFixed(2)));
    // setSaldo(totTemp - efectivo - tdc - transfer);
  }

  const options = clientes.map((option) => {
    const junta = option.nombre_comercial + " " + option.codigo;
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  function calculaImpuesto(e) {
    setSelectedImpuesto(parseFloat(e));
    // El useEffect([..., selectedImpuesto]) recalcula todo desde TG con la nueva tasa
  }

  function jalaComisionTDC(e) {
    setComisionTDC(parseFloat(e));
    const taxRateTDC = parseFloat(selectedImpuesto) || 0;
    let descuentoMonto = getDescuentoMonto(subTotal, descuentoTipo, descuento, taxRateTDC);
    let baseConDescuento = subTotal - descuentoMonto;
    let totTemp =
      baseConDescuento +
      iva +
      parseFloat(e) +
      parseFloat(comisionFlete);

    setTotalGeneral(parseFloat(totTemp.toFixed(2)));
    // setSaldo(totTemp - efectivo - tdc - transfer);
  }

  function jalaComisionFlete(e) {
    setComisionFlete(parseFloat(e));
    const taxRateFlete = parseFloat(selectedImpuesto) || 0;
    let descuentoMonto = getDescuentoMonto(subTotal, descuentoTipo, descuento, taxRateFlete);
    let baseConDescuento = subTotal - descuentoMonto;
    let totTemp =
      baseConDescuento +
      iva +
      parseFloat(comisionTDC) +
      parseFloat(e);

    setTotalGeneral(parseFloat(totTemp.toFixed(2)));
    // setSaldo(totTemp - efectivo - tdc - transfer);
  }

  function getDescuentoMonto(subTotalVal, tipo, val, taxRate = 0) {
    const v = parseFloat(val) || 0;
    if (tipo === "$") {
      // Convertir el monto IVA-inclusive a su equivalente pre-IVA para que el total resulte TG - v
      const preTaxVal = taxRate > 0 ? v / (1 + taxRate / 100) : v;
      return Math.min(preTaxVal, subTotalVal);
    }
    return subTotalVal * v / 100;
  }

  function jalaDescuento(e) {
    setDescuento(parseFloat(e));
    const taxRateD = parseFloat(selectedImpuesto) || 0;
    let descuentoMonto = getDescuentoMonto(subTotal, descuentoTipo, e, taxRateD);
    let baseConDescuento = subTotal - descuentoMonto;
    let ivaAmount = taxRateD > 0 ? baseConDescuento * (taxRateD / 100) : 0;
    setIva(ivaAmount);

    let totTemp =
      baseConDescuento +
      ivaAmount +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete);

    setTotalGeneral(parseFloat(totTemp.toFixed(2)));
    // setSaldo(totTemp - efectivo - tdc - transfer);
  }

  function jalaDescuentoTipo(tipo) {
    setDescuentoTipo(tipo);
    setDescuento(0);
    const taxRateD = parseFloat(selectedImpuesto) || 0;
    let ivaAmount = taxRateD > 0 ? subTotal * (taxRateD / 100) : 0;
    setIva(ivaAmount);
    let totTemp = subTotal + ivaAmount + parseFloat(comisionTDC) + parseFloat(comisionFlete);
    setTotalGeneral(parseFloat(totTemp.toFixed(2)));
  }

  function autorizaCambio() {
    if (password === randomCambiaPrecio) {
      setCambiarPrecio(true);
      toggleCambiaPrecio();
      Swal.fire("Good job!", "Se autorizo con exito", "success");
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La contraseña es incorrecta!",
      });
    }
  }

  function jalaCondPago(e) {
    setCondPago(e);
    setEfectivo(0);
    setTDC(0);
    setTransfer(0);
    setDeposito(0);
    setCheque(0);
    //setSaldo(total_general);
    setFechaTransfer("NA");
    setDestino("NA");
    setTerminal("NA");
    setDestinoDeposito("NA");
    setFechaDeposito("NA");
    setDestinoCheque("NA");
    setFechaCheque("NA");
    setNumeroCheque("NA");
    setDescuento(0);
    setDescuentoTipo("%");
  }

  function jalaEfectivo(e) {
    setEfectivo(e);
    // setSaldo(total_general - e - tdc - transfer);
  }

  function jalaTransfer(e) {
    setTransfer(e);
    if (e > 0) {
      setDestino("");
    } else {
      setDestino("NA");
    }
    //setSaldo(total_general - efectivo - tdc - e);
  }

  function jalaDeposito(e) {
    setDeposito(e);
    if (e > 0) {
      setDestinoDeposito("");
    } else {
      setDestinoDeposito("NA");
    }
  }

  function jalaCheque(e) {
    setCheque(e);
    if (e > 0) {
      setDestinoCheque("");
      setNumeroCheque("");
    } else {
      setDestinoCheque("NA");
      setFechaCheque("NA");
      setNumeroCheque("NA");
    }
  }

  function jalaTDC(e) {
    setTDC(e);
    if (e > 0) {
      setTerminal("");
    } else {
      setTerminal("NA");
    }
    // setSaldo(total_general - efectivo - e - transfer);
  }

  function solicitarAut() {
    setMailAutEnviado(true);

    axios.post(
      `${URL_WHATSAPP}SendMsg`,
      {
        number: import.meta.env.VITE_TELEFONO_SUPER_ADMIN,
        message: `Hola,
La tienda ${areaUserName} esta solicitando un cambio de precio.
Si lo autorizas proporciona la clave:
${randomCambiaPrecio}`,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    axios
      .post(
        URL_SEND_MAIL,
        {
          subject: "Cambio de Precio",
          email: import.meta.env.VITE_EMAIL_SUPER_ADMIN,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
       <th><img width="${import.meta.env.VITE_TAMANO_LOGO_MAIL}" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}logoInstitucion.png" /></th>
       <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${import.meta.env.VITE_NOMBRE_INSTITUCION}</tr>
       <tbody>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>La tienda ${areaUserName} esta solicitando un cambio de precio, si lo autorizas proporciona la clave ${randomCambiaPrecio}</tr>
       </tbody>
       <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${import.meta.env.VITE_TELEFONO_INSTITUCION}</tr>
       <tr align="right"><br>Powered by <a href="https://sistemify.com"> <img width="20%" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}Logo-Sistemify-PDF.png" /> </a> </tr>
       </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )

      .then(() => {
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

  const options2 = articulosUnicos.map((option) => {
    const junta = option.codigo;
    const firstLetter = option.codigo[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  const handleChangeInputProporcion = (id, event) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        if (event.target.name === "precio") {
          i[event.target.name] = parseFloat(event.target.value);
        } else {
          i[event.target.name] = event.target.value;
        }
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
  };

  function BuscaArticuloProporcion(id, selectedArticulo) {
    inventarios.map((a) => {
      if (a.idArticulo === selectedArticulo.idArticulo) {
        let idArticulo = selectedArticulo.idArticulo;
        let articulosNombre =
          selectedArticulo.codigo + " " + selectedArticulo.nombre;
        let colores = a.colores;
        let tallas = a.tallas;

        jalaFoto(a.idArticulo, a.urlFoto);

        let precio;
        if (listaPrecios == 1) {
          precio = a.lista1;
        } else if (listaPrecios == 2) {
          precio = a.lista2;
        } else if (listaPrecios == 3) {
          precio = a.lista3;
        } else if (listaPrecios == 4) {
          precio = a.lista4;
        }

        handleChangeInputArticuloProporcion(
          id,
          idArticulo,
          precio,
          articulosNombre,
          colores,
          tallas
        );
      }
    });
  }

  function BuscaCodigoProporcion(id, event) {
    // Campo NO controlado: el navegador acumula los caracteres del escáner sin que
    // React reescriba el value (eso corrompía las lecturas rápidas del escáner).
    const inputEl = event.target;
    const codigo = (inputEl.value || "").trim();

    if (codigo.length <= 2) {
      // Limpia la selección previa al empezar a escribir/escanear un código nuevo
      const newInputArticulos = inputArticulos.map((i) => {
        if (id === i.id) {
          i.articulos = "";
          i.precio = 0;
          i.articulosNombre = "";
          i.cajas = 0;
          i.colores = [];
          i.tallas = [];
        }
        return i;
      });
      setInputArticulos(newInputArticulos);
      return;
    }

    let encontrado = false;
    inventarios.map((a) => {
      if (a.ean == codigo) {
        encontrado = true;
        let articulosNombre = a.codigo + " " + a.nombre;
        let colores = a.colores;
        let tallas = a.tallas;
        let idArticulo = a.idArticulo;

        jalaFoto(a.idArticulo, a.urlFoto);

        let precio;
        if (listaPrecios == 1) {
          precio = a.lista1;
        } else if (listaPrecios == 2) {
          precio = a.lista2;
        } else if (listaPrecios == 3) {
          precio = a.lista3;
        } else if (listaPrecios == 4) {
          precio = a.lista4;
        }

        handleChangeInputArticuloProporcion(
          id,
          idArticulo,
          precio,
          articulosNombre,
          colores,
          tallas
        );
      }
    });

    if (encontrado) {
      // Limpia el campo para el siguiente escaneo
      inputEl.value = "";
    }
  }

  const handleChangeInputArticuloProporcion = (
    id,
    idArticulo,
    precio,
    articulosNombre,
    colores,
    tallas
  ) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.precio = precio;
        i.articulosNombre = articulosNombre;
        i.cajas = 0;
        i.colores = colores;
        i.tallas = tallas;
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
  };

  function agregarProporcion(
    idArticulo,
    articulosNombre,
    precio,
    cajas,
    colores,
    tallas
  ) {
    if (cajas === 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La cantidad debe ser mayor a 0",
      });
      return;
    }

    // Limpiar el input de escaneo inmediatamente para que el siguiente scan empiece en blanco
    setInputArticulos([
      {
        id: uuidv4(),
        articulos: "",
        cajas: 0,
        precio: 0,
        articulosNombre: "",
        colores: [],
        tallas: [],
      },
    ]);

    axios
      .get(`${URL_ARTICULOS_PROPORCION}Articulos/${idArticulo}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;

        // Remove the duplicate check and error - we'll handle duplicates differently
        // const avaiable = inputFields.find((a) => {
        //   if (a.articulos === inputArticulos[0].articulos) {
        //     Swal.fire({
        //       icon: "error",
        //       title: "Oops...",
        //       text: "El artículo ya ha sido agregado",
        //       showConfirmButton: false,
        //     });
        //     return true;
        //   }
        //   return false;
        // });
        // if (avaiable) {
        //   return;
        // }

        const newInputFields = allArticulos
          .map((i) => {
            // Encuentra el inventario correspondiente
            const inventario = inventarios.find(
              (inv) =>
                inv.idArticulo === i.articulos[0]._id &&
                inv.color === i.colores[0].name &&
                inv.talla === i.tallas[0].name
            );

            // Calcula la cantidad final basada en la disponibilidad del inventario
            const cantidadFinal = inventario
              ? Math.min(inventario.cantidad, i.cantidad * cajas)
              : i.cantidad * cajas;

            if (inventario) {
              return {
                id: uuidv4(),
                articulos: idArticulo,
                precio: precio,
                idInv: inventario._id,
                cantInv: inventario.cantidad,
                articulosNombre: articulosNombre,

                precioEsp: inventario.precioEsp,
                venta: inventario.venta,
                costoUnitario: inventario.costoUnitario,
                precioOriginal: inventario.venta,
                cantidad: cantidadFinal,
                total: cantidadFinal * precio,

                idTalla: i.tallas[0]._id,
                tallaNombre: i.tallas[0].name,
                idColor: i.colores[0]._id,
                colorNombre: i.colores[0].name,
                colores: colores,
                tallas: tallas,
                cajas: cantidadFinal / inventario.piezasPorCaja,
                idArticuloProporcion: i._id,
              };
            }
            return null;
          })
          .filter((i) => i !== null && i.cantidad > 0);

        setInputFields((prevInputFields) => {
          // Check for existing items with the same idArticuloProporcion and merge them
          const mergedFields = [...prevInputFields];

          newInputFields.forEach((newField) => {
            const existingIndex = mergedFields.findIndex(
              (field) => field.idArticuloProporcion === newField.idArticuloProporcion
            );

            if (existingIndex !== -1) {
              // If item exists, add the quantities together
              mergedFields[existingIndex] = {
                ...mergedFields[existingIndex],
                cantidad: mergedFields[existingIndex].cantidad + newField.cantidad,
                total: (mergedFields[existingIndex].cantidad + newField.cantidad) * mergedFields[existingIndex].precio,
                cajas: mergedFields[existingIndex].cajas + newField.cajas,
              };
            } else {
              // If item doesn't exist, add it to the array
              mergedFields.push(newField);
            }
          });


          const sortedInputFields = mergedFields.sort((a, b) => {
            if (a.articulosNombre < b.articulosNombre) return -1;
            if (a.articulosNombre > b.articulosNombre) return 1;

            if (a.colorNombre < b.colorNombre) return -1;
            if (a.colorNombre > b.colorNombre) return 1;

            return (
              customSizeOrder.indexOf(a.tallaNombre) -
              customSizeOrder.indexOf(b.tallaNombre)
            );
          });

          // Calculate total quantities and amounts
          const totalCantidad = sortedInputFields.reduce(
            (acc, curr) => acc + parseFloat(curr.cantidad),
            0
          );
          const TG = sortedInputFields.reduce(
            (acc, curr) => acc + parseFloat(curr.total),
            0
          );

          // Update state with totals (precios ya incluyen IVA, desglosar igual que ActualizaTotales)
          setTotalCantidad(totalCantidad);
          const taxRate2 = parseFloat(selectedImpuesto) || 0;
          let subTotalSinIva = taxRate2 > 0 ? TG / (1 + taxRate2 / 100) : TG;
          setSubTotal(subTotalSinIva);

          // Aplicar descuento sobre el subtotal sin IVA
          let descuentoMonto = getDescuentoMonto(subTotalSinIva, descuentoTipo, descuento, taxRate2);
          let baseConDescuento = subTotalSinIva - descuentoMonto;
          let ivaAmount = taxRate2 > 0 ? baseConDescuento * (taxRate2 / 100) : 0;
          setIva(ivaAmount);

          let totTemp =
            baseConDescuento +
            ivaAmount +
            parseFloat(comisionTDC) +
            parseFloat(comisionFlete);

          setTotalGeneral(parseFloat(totTemp.toFixed(2)));
          setSaldo(parseFloat((totTemp - efectivo - tdc - transfer - deposito - cheque).toFixed(2)));

          return sortedInputFields;
        });

        // Mostrar toast sin bloquear el teclado del escáner
        Swal.fire({
          icon: "success",
          title: `+${cajas} cajas: ${articulosNombre}`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 1200,
          timerProgressBar: true,
        });
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Hubo un problema al agregar la proporción",
        });
      });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.ventasTiendas ? (
        <div className="card" style={{ padding: "0 15px 15px 15px", overflowX: "hidden" }}>
          <h3 align="center">Nueva Venta</h3>
          <div style={{ textAlign: "center", marginBottom: "10px" }}>
            <span style={{ background: "#e8f4fd", border: "1px solid #90caf9", borderRadius: "6px", padding: "4px 14px", fontSize: "13px", color: "#1565c0" }}>
              Cajero activo: <strong>{user.nombre} {user.apellido}</strong>
            </span>
          </div>
          <Form onSubmit={saveVenta} onKeyDown={(e) => { if (e.key === "Enter") e.preventDefault(); }}>
            {/* Checkbox nuevo cliente */}
            <div className="mb-2">
              {selectedArea !== "" ? (
                <>
                  <Input
                    type="checkbox"
                    onChange={(event) => {
                      setVistaCliente(event.currentTarget.checked);
                      setAlertasCliente("Si");
                      if (event.currentTarget.checked) setModalAltaCliente(true);
                    }}
                    checked={vistaCliente}
                  />
                  <span className="subMenuTitulo">Deseas Dar de alta al Cliente?</span>
                  {vistaCliente && (
                    <Button size="sm" color="link" className="ml-2 p-0" onClick={toggleAltaCliente}>
                      (Ver / Editar datos)
                    </Button>
                  )}
                </>
              ) : (
                <>
                  <Input type="checkbox" disabled />
                  <span className="ml-2 subMenuTitulo">Deseas Dar de alta al Cliente?</span>
                </>
              )}
            </div>

            {/* Modal Alta Cliente */}
            {vistaCliente ? (
              <Modal size="xl" isOpen={modalAltaCliente} toggle={toggleAltaCliente}>
                <ModalHeader toggle={toggleAltaCliente}>
                  <h5 className="mb-0">Datos del Nuevo Cliente</h5>
                </ModalHeader>
                <ModalBody style={{ backgroundColor: "#fff", color: "#212529" }}>
                  <div>
                    <Row>
                      <Col md={3}>
                        <Label>Nombre Comercial</Label>
                        <Input type="text" style={{ backgroundColor: "yellow" }} placeholder="Nombre Comercial" value={nombre_comercial} required onChange={(e) => setNombreComercial(e.target.value)} />
                      </Col>
                      <Col md={2}>
                        <Label>Razon Social</Label>
                        <Input type="text" placeholder="Razon Social" value={razon_social} required onChange={(e) => setRazonSocial(e.target.value)} />
                      </Col>
                      <Col md={1}>
                        <Label>RFC</Label>
                        <Input type="text" placeholder="RFC" value={RFC} required onChange={(e) => setRFC(e.target.value)} />
                      </Col>
                      <Col md={2}>
                        <Label>Telefono</Label>
                        <Input type="text" style={{ backgroundColor: "yellow" }} placeholder="Telefono" value={telefono} required onChange={(e) => setTelefono(e.target.value)} />
                      </Col>
                      <Col md={2}>
                        <Label>Email</Label>
                        <Input type="email" placeholder="Email" value={email} required onChange={(e) => setEmail(e.target.value)} />
                      </Col>
                      <Col md={2}>
                        <Label className="mr-sm-2">Vendedor</Label>
                        <Input style={{ backgroundColor: "yellow" }} className="col-sm-12" type="select" value={selectedVendedorInput} required onChange={(e) => eligeVendedor(e.target.value)}>
                          <option value="0">Selecciona un Vendedor</option>
                          {colaboradores.sort((a, b) => (a.nombre > b.nombre ? 1 : -1)).map((a) => (
                            <option key={a._id} value={[a._id, a.nombre + " " + a.apellido]}>{a.nombre} {a.apellido}</option>
                          ))}
                        </Input>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col md={4}>
                        <Label>Calle</Label>
                        <Input type="text" placeholder="Calle" value={calle} required onChange={(e) => setCalle(e.target.value)} />
                      </Col>
                      <Col md={1}>
                        <Label>No. Ext</Label>
                        <Input type="text" placeholder="No. Ext" value={numero_ext} required onChange={(e) => setNumeroExt(e.target.value)} />
                      </Col>
                      <Col md={1}>
                        <Label>No. Int</Label>
                        <Input type="text" placeholder="No. Int" value={numero_int} required onChange={(e) => setNumeroInt(e.target.value)} />
                      </Col>
                      <Col md={2}>
                        <Label>Colonia</Label>
                        <Input type="text" placeholder="Colonia" value={colonia} required onChange={(e) => setColonia(e.target.value)} />
                      </Col>
                      <Col md={2}>
                        <Label>Ciudad</Label>
                        <Input type="text" placeholder="Ciudad" value={ciudad} required onChange={(e) => setCiudad(e.target.value)} />
                      </Col>
                      <Col md={1}>
                        <Label>Estado</Label>
                        <Input type="text" placeholder="Estado" value={estado} required onChange={(e) => setEstado(e.target.value)} />
                      </Col>
                      <Col md={1}>
                        <Label>CP</Label>
                        <Input type="text" placeholder="CP" value={cp} required onChange={(e) => setCP(e.target.value)} />
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col md={2}>
                        <Label>Delegacion</Label>
                        <Input type="text" placeholder="Delegacion o Municipio" value={delegacion} required onChange={(e) => setDelegacion(e.target.value)} />
                      </Col>
                      <Col md={1}>
                        <Label>Pais</Label>
                        <Input type="text" placeholder="Pais" value={pais} required onChange={(e) => setPais(e.target.value)} />
                      </Col>
                      <Col md={2}>
                        <Label className="mr-sm-2">Paqueteria</Label>
                        <Input className="col-sm-12" style={{ backgroundColor: "yellow" }} type="select" value={selectedPaqueteria} required onChange={(e) => setSelectedPaqueteria(e.target.value)}>
                          <option value="0">Selecciona </option>
                          {paqueterias.sort((a, b) => (a.name > b.name ? 1 : -1)).map((a) => (
                            <option key={a._id} value={a._id}>{a.name}</option>
                          ))}
                        </Input>
                      </Col>
                      <Col md={2}>
                        <Label className="mr-sm-2">Grupo</Label>
                        <Input className="col-sm-12" style={{ backgroundColor: "yellow" }} type="select" value={selectedGrupo} required onChange={(e) => setSelectedGrupo(e.target.value)}>
                          <option value="0">Selecciona una Grupo</option>
                          {grupos.sort((a, b) => (a.name > b.name ? 1 : -1)).map((a) => (
                            <option key={a._id} value={a._id}>{a.name}</option>
                          ))}
                        </Input>
                      </Col>
                      <Col md={2}>
                        <Label className="mr-sm-2">Departamento</Label>
                        <Input className="col-sm-12" style={{ backgroundColor: "yellow" }} type="select" value={selectedDepartamento} required onChange={(e) => setSelectedDepartamento(e.target.value)}>
                          <option value="0">Selecciona </option>
                          {departamentos.sort((a, b) => (a.name > b.name ? 1 : -1)).map((a) => (
                            <option key={a._id} value={a._id}>{a.name}</option>
                          ))}
                        </Input>
                      </Col>
                      <Col md={1}>
                        <Label>Forma de Pago</Label>
                        <Input type="select" value={forma_pago} required onChange={(e) => setFormaPago(e.target.value)}>
                          <option value="0">Forma de Pago</option>
                          <option value="Contado">Contado</option>
                          <option value="Credito">Credito</option>
                        </Input>
                      </Col>
                      <Col md={2}>
                        <Label>Plazo</Label>
                        <Input type="select" value={plazo} required onChange={(e) => setPlazo(e.target.value)}>
                          <option value="">Plazo</option>
                          <option value="0">0</option>
                          <option value="30">30</option>
                          <option value="60">60</option>
                          <option value="90">90</option>
                          <option value="120">120</option>
                          <option value="150">150</option>
                          <option value="180">180</option>
                        </Input>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col md={2}>
                        <Label>Reg Fiscal</Label>
                        <Input type="select" value={regFiscal} required onChange={(e) => setRegFiscal(e.target.value)}>
                          <option value="">Reg Fiscal</option>
                          <option value="0">0</option>
                          <option value="601">601 General de Ley Personas Morales</option>
                          <option value="603">603 Personas Morales con Fines no Lucrativos</option>
                          <option value="605">605 Sueldos y Salarios e Ingresos Asimilados al Salario</option>
                          <option value="608">608 Demas Ingresos</option>
                          <option value="612">612 Personas Fisicas con Actividad Empresarial</option>
                          <option value="616">616 Sin Obligacion Fiscal</option>
                          <option value="621">621 Incorporacion Fiscal</option>
                          <option value="625">625 Reg. de las act. emp. cpn ingresos a traves de plat. tec.</option>
                          <option value="626">626 Regimen simplificado de Confianza</option>
                        </Input>
                      </Col>
                      <Col md={2}>
                        <Label>Uso de CDFI</Label>
                        <Input type="select" value={usoCFDI} required onChange={(e) => setUsoCFDI(e.target.value)}>
                          <option value="">Selecciona</option>
                          <option value="G01">G01 Adquisición de mercancías</option>
                          <option value="G03">G03 Gastos en general</option>
                          <option value="S01">S01 Sin efectos fiscales</option>
                        </Input>
                      </Col>
                      <Col md={2}>
                        <Label>Forma Pago Fiscal</Label>
                        <Input style={{ backgroundColor: "yellow" }} type="select" value={formaPagoSAT} required onChange={(e) => setFormaPagoSAT(e.target.value)}>
                          <option value="">Selecciona</option>
                          <option value="01"> 01 Efectivo</option>
                          <option value="02"> 02 Cheque nominativo</option>
                          <option value="03"> 03 Transferencia electrónica de fondos</option>
                          <option value="04"> 04 Tarjeta de crédito</option>
                          <option value="05"> 05 Monedero electrónico</option>
                          <option value="06"> 06 Dinero electrónico</option>
                          <option value="08"> 08 Vales de despensa</option>
                          <option value="12"> 12 Dación en pago</option>
                          <option value="13"> 13 Pago por subrogación</option>
                          <option value="14"> 14 Pago por consignación</option>
                          <option value="15"> 15 Condonación</option>
                          <option value="17"> 17 Compensación</option>
                          <option value="23"> 23 Novación</option>
                          <option value="24"> 24 Confusión</option>
                          <option value="25"> 25 Remisión de deuda</option>
                          <option value="26"> 26 Prescripción o caducidad</option>
                          <option value="27"> 27 A satisfacción del acreedor</option>
                          <option value="28"> 28 Tarjeta de débito</option>
                          <option value="29"> 29 Tarjeta de servicios</option>
                          <option value="30"> 30 Aplicación de anticipos</option>
                          <option value="99"> 99 Por definir</option>
                        </Input>
                      </Col>
                      <Col md={2}>
                        <Label>Metodo Pago Fiscal</Label>
                        <Input type="select" value={metodoPagoSAT} required onChange={(e) => setMetodoPagoSAT(e.target.value)}>
                          <option value="">Selecciona</option>
                          <option value="PUE">PUE (Pago de Una Sola Exhibición)</option>
                          <option value="PPD">PPD (Pago en Parcialidades o Diferido)</option>
                        </Input>
                      </Col>
                      <Col md={2}>
                        <Label>Condiciones de Pago Fiscal</Label>
                        <Input type="text" value={condicionesPagoSAT} required onChange={(e) => setCondicionesPagoSAT(e.target.value)} />
                      </Col>
                      <Col md={2}>
                        <Label>Observaciones Cliente</Label>
                        <Input type="text" placeholder="Observaciones" value={observacionesCliente} required onChange={(e) => setObservacionesCliente(e.target.value)} />
                      </Col>
                    </Row>
                  </div>
                </ModalBody>
              </Modal>
            ) : undefined}
            {/* Layout principal de dos columnas */}
            <Row>
              {/* PANEL IZQUIERDO */}
              <Col md={3} style={{ borderRight: "1px solid #dee2e6", paddingRight: "12px", fontSize: "13px" }}>

                {/* ── CLIENTE ── */}
                <p className="text-muted text-uppercase mb-1 mt-1" style={{ fontSize: "10px", letterSpacing: "1px", fontWeight: 600 }}>Cliente</p>
                {!vistaCliente ? (
                  <>
                    {selectedArea !== "" ? (
                      <>
                        <FormGroup className="mb-1">
                          <Label className="mb-0">Cliente</Label>
                          <Autocomplete
                            size="small"
                            value={value}
                            onChange={(event, selectedCliente) => {
                              if (selectedCliente) {
                                setValue(selectedCliente);
                                setAlertasCliente(selectedCliente.alertas);
                                setSelectedColaborador(selectedCliente.vendedor?.[0]?._id || "");
                                setListaPrecios(selectedCliente.listaPrecios);
                                // Se propone el vendedor del cliente, pero sin
                                // tapar el que ya hayan elegido a mano. Antes
                                // esto cambiaba solo el nombre del ticket y
                                // dejaba guardado otro vendedor distinto.
                                if (!vendedorTocadoRef.current) aplicaVendedor(selectedCliente.vendedor?.[0]);
                              }
                            }}
                            options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                            groupBy={(option) => option.firstLetter}
                            getOptionLabel={(option) => option?.junta || ""}
                            renderInput={(params) => <TextField {...params} label="Selecciona" variant="outlined" />}
                            renderOption={(props, option) => (
                              <li {...props} key={option._id}>{option.codigo} {option.nombre_comercial}</li>
                            )}
                          />
                        </FormGroup>
                        <FormGroup className="mb-1">
                          <Row>
                            <Col md={4}>
                              <Label className="mb-0">Vendedor</Label>
                              <Input bsSize="sm" style={{ backgroundColor: "yellow" }} type="select" value={selectedVendedorInput} required onChange={(e) => eligeVendedor(e.target.value)}>
                                <option value="0">Selecciona un Vendedor</option>
                                {colaboradores.sort((a, b) => (a.nombre > b.nombre ? 1 : -1)).map((a) => (
                                  <option key={a._id} value={[a._id, a.nombre + " " + a.apellido]}>{a.nombre} {a.apellido}</option>
                                ))}
                              </Input>
                            </Col>
                            <Col md={4}>
                              <Label className="mb-0">Paqueteria</Label>
                              <Input bsSize="sm" type="select" value={idPaqueteria} required onChange={(e) => setIdPaqueteria(e.target.value)}>
                                <option value="0">Selecciona</option>
                                {paqueterias.sort((a, b) => (a.name > b.name ? 1 : -1)).map((a) => (
                                  <option key={a._id} value={a._id}>{a.name}</option>
                                ))}
                              </Input>
                            </Col>
                            <Col md={4}>
                              <Label className="mb-0">Lista Precios</Label>
                              <Input
                                bsSize="sm"
                                type="select"
                                value={listaPrecios}
                                onChange={(e) => setListaPrecios(parseInt(e.target.value))}
                              >
                                <option value={1}>Lista 1</option>
                                <option value={2}>Lista 2</option>
                                <option value={3}>Lista 3</option>
                                <option value={4}>Lista 4</option>
                              </Input>
                            </Col>
                          </Row>
                        </FormGroup>
                      </>
                    ) : (
                      <>
                        <FormGroup className="mb-1">
                          <Label className="mb-0">Cliente</Label>
                          <Autocomplete
                            size="small"
                            value={value}
                            onChange={(event, selectedCliente) => {
                              if (selectedCliente) {
                                setValue(selectedCliente);
                                setSelectedColaborador(selectedCliente.vendedor?.[0]?._id || "");
                                if (!vendedorTocadoRef.current) aplicaVendedor(selectedCliente.vendedor?.[0]);
                              }
                            }}
                            disabled
                            options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                            groupBy={(option) => option.firstLetter}
                            getOptionLabel={(option) => option?.junta || ""}
                            renderInput={(params) => <TextField {...params} label="Selecciona" variant="outlined" />}
                            renderOption={(props, option) => (
                              <li {...props} key={option._id}>{option.codigo} {option.nombre_comercial}</li>
                            )}
                          />
                        </FormGroup>
                        <FormGroup className="mb-1">
                          <Label className="mb-0">Vendedor</Label>
                          <Input bsSize="sm" style={{ backgroundColor: "yellow" }} type="select" value={selectedVendedorInput} required onChange={(e) => eligeVendedor(e.target.value)}>
                            <option value="0">Selecciona un Vendedor</option>
                            {colaboradores.sort((a, b) => (a.nombre > b.nombre ? 1 : -1)).map((a) => (
                              <option key={a._id} value={[a._id, a.nombre + " " + a.apellido]}>{a.nombre} {a.apellido}</option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup className="mb-1">
                          <Label className="mb-0">Paqueteria</Label>
                          <Input bsSize="sm" type="select" value={idPaqueteria} required disabled>
                            <option value="0">Selecciona</option>
                            {paqueterias.sort((a, b) => (a.name > b.name ? 1 : -1)).map((a) => (
                              <option key={a._id} value={a._id}>{a.name}</option>
                            ))}
                          </Input>
                        </FormGroup>
                      </>
                    )}
                  </>
                ) : undefined}
                <FormGroup className="mb-1">
                  <Row><Col md={6}>
                    <Label className="mb-0">Observaciones</Label>
                    <Input bsSize="sm" type="text" placeholder="Observaciones" value={observaciones} required onChange={(e) => setObservaciones(e.target.value)} />
                  </Col>
                    <Col md={6}>
                      <div className="mb-2">
                        <Button size="sm" color="info" onClick={toggleCambiaPrecio}>Cambio de Precio</Button>
                      </div>
                    </Col>
                  </Row>
                </FormGroup>

                <hr className="my-2" />

                {/* ── CONFIG VENTA ── */}
                <p className="text-muted text-uppercase mb-1" style={{ fontSize: "10px", letterSpacing: "1px", fontWeight: 600 }}>Configuración Venta</p>

                {/* Com. TDC + Flete en la misma fila */}
                <Row form className="mb-1 align-items-end">
                  <Col xs={3}><Label className="mb-0" style={{ fontSize: "11px" }}>Com. TDC</Label><Input bsSize="sm" type="number" min="0" step="any" value={comisionTDC} required onChange={(e) => jalaComisionTDC(e.target.value)} /></Col>
                  <Col xs={3}><Label className="mb-0" style={{ fontSize: "11px" }}>Flete</Label><Input bsSize="sm" type="number" min="0" step="any" value={comisionFlete} required onChange={(e) => jalaComisionFlete(e.target.value)} /></Col>
                  <Col xs={3}><Label className="mb-0" style={{ fontSize: "11px" }}>IVA %</Label><Input bsSize="sm" type="number" min="0" step="any" value={selectedImpuesto} onChange={(e) => calculaImpuesto(e.target.value)} /></Col>
                  <Col xs={3}>
                    <Label className="mb-0" style={{ fontSize: "11px" }}>Desc.</Label>
                    <div style={{ display: "flex", gap: "2px" }}>
                      <button type="button" onClick={() => jalaDescuentoTipo("%")} style={{ padding: "2px 5px", fontSize: "11px", fontWeight: 600, border: "1px solid #ccc", borderRadius: "3px", background: descuentoTipo === "%" ? "#1a73e8" : "#f8f9fa", color: descuentoTipo === "%" ? "#fff" : "#333", cursor: "pointer", whiteSpace: "nowrap" }}>%</button>
                      <button type="button" onClick={() => jalaDescuentoTipo("$")} style={{ padding: "2px 5px", fontSize: "11px", fontWeight: 600, border: "1px solid #ccc", borderRadius: "3px", background: descuentoTipo === "$" ? "#1a73e8" : "#f8f9fa", color: descuentoTipo === "$" ? "#fff" : "#333", cursor: "pointer", whiteSpace: "nowrap" }}>$</button>
                      <Input bsSize="sm" type="number" min="0" max={descuentoTipo === "%" ? 100 : undefined} step="any" value={descuento} onChange={(e) => jalaDescuento(e.target.value)} style={{ flex: 1, minWidth: 0 }} />
                    </div>
                  </Col>
                </Row>

                <hr className="my-2" />

                {/* ── TOTALES ── */}
                <p className="text-muted text-uppercase mb-1" style={{ fontSize: "10px", letterSpacing: "1px", fontWeight: 600 }}>Totales</p>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px" }}><span>Piezas:</span><span>{new Intl.NumberFormat("en-US").format(total_cantidad)}</span></div>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px" }}><span>Subtotal:</span><span>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(subTotal)}</span></div>
                {descuento > 0 && (
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", color: "#dc3545" }}><span>Descuento {descuentoTipo === "%" ? `${descuento}%` : new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(descuento)}:</span><span>-{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(getDescuentoMonto(subTotal, descuentoTipo, descuento))}</span></div>
                )}
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px" }}><span>IVA:</span><span>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(iva)}</span></div>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "14px" }} className="mt-1"><strong>Total:</strong><strong>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(total_general)}</strong></div>

                <hr className="my-2" />

                {/* ── FORMA DE PAGO (Cond. de Pago va aquí arriba) ── */}
                <p className="text-muted text-uppercase mb-1" style={{ fontSize: "10px", letterSpacing: "1px", fontWeight: 600 }}>Forma de Pago</p>

                {/* Caja */}
                <div style={{ marginBottom: "4px" }}>
                  <div style={{ fontSize: "11px", marginBottom: "1px" }}>Caja</div>
                  <Input bsSize="sm" type="select" value={caja} onChange={(e) => setCaja(e.target.value)}>
                    <option value="">Selecciona Caja</option>
                    {cajas.map((c) => <option key={c._id} value={c._id}>{c.nombre}</option>)}
                  </Input>
                  {cajas.length === 0 && (
                    <small className="text-danger d-block">
                      No hay cajas activas para tu tienda.
                    </small>
                  )}
                </div>

                {/* Cond. Pago + Efectivo */}
                <div style={{ display: "flex", gap: "6px", marginBottom: "4px" }}>
                  <div style={{ flex: "0 0 44%" }}>
                    <div style={{ fontSize: "11px", marginBottom: "1px" }}>Cond. Pago</div>
                    <Input bsSize="sm" type="select" value={condPago} required onChange={(e) => jalaCondPago(e.target.value)}>
                      <option value="Contado">Contado</option>
                      <option value="Credito">Credito</option>
                    </Input>
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "11px", marginBottom: "1px" }}>Efectivo</div>
                    {condPago === "Contado"
                      ? <Input bsSize="sm" type="number" min="0" step="any" value={efectivo} required onChange={(e) => jalaEfectivo(e.target.value)} />
                      : <Input bsSize="sm" type="number" min="0" step="any" value={efectivo} required disabled />}
                  </div>
                </div>

                {/* TDC + Terminal */}
                <div style={{ display: "flex", gap: "6px", marginBottom: "4px" }}>
                  <div style={{ flex: "0 0 44%" }}>
                    <div style={{ fontSize: "11px", marginBottom: "1px" }}>TDC</div>
                    {condPago === "Contado"
                      ? <Input bsSize="sm" type="number" min="0" step="any" value={tdc} required onChange={(e) => jalaTDC(e.target.value)} />
                      : <Input bsSize="sm" type="number" min="0" step="any" value={tdc} disabled />}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "11px", marginBottom: "1px" }}>Terminal</div>
                    {condPago === "Contado" && tdc > 0
                      ? <Input bsSize="sm" type="select" value={terminal} required onChange={(e) => setTerminal(e.target.value)}>
                          <option value="NA">Selecciona</option>
                          {bancos.map((b) => <option key={b._id} value={b.banco}>{b.banco}{b.cuenta !== "No" ? ` - ${b.cuenta}` : ""}</option>)}
                        </Input>
                      : <Input bsSize="sm" type="text" value={terminal} disabled />}
                  </div>
                </div>

                {/* Transfer + Destino */}
                <div style={{ display: "flex", gap: "6px", marginBottom: "4px" }}>
                  <div style={{ flex: "0 0 44%" }}>
                    <div style={{ fontSize: "11px", marginBottom: "1px" }}>Transfer</div>
                    {condPago === "Contado"
                      ? <Input bsSize="sm" type="number" min="0" step="any" value={transfer} required onChange={(e) => jalaTransfer(e.target.value)} />
                      : <Input bsSize="sm" type="number" min="0" step="any" value={transfer} required disabled />}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "11px", marginBottom: "1px" }}>Destino</div>
                    {condPago === "Contado" && transfer > 0
                      ? <Input bsSize="sm" type="select" value={destino} required onChange={(e) => setDestino(e.target.value)}>
                          <option value="NA">Selecciona</option>
                          {bancos.map((b) => <option key={b._id} value={b.banco}>{b.banco}{b.cuenta !== "No" ? ` - ${b.cuenta}` : ""}</option>)}
                        </Input>
                      : <Input bsSize="sm" type="text" value={destino} disabled />}
                  </div>
                </div>

                {/* Fecha Transfer */}
                <div style={{ display: "flex", gap: "6px", marginBottom: "4px" }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "11px", marginBottom: "1px" }}>Fecha Transfer</div>
                    {condPago === "Contado" && transfer > 0
                      ? <Input bsSize="sm" type="date" value={fechaTransfer} required onChange={(e) => setFechaTransfer(e.target.value)} />
                      : <Input bsSize="sm" type="date" value={fechaTransfer} disabled />}
                  </div>
                </div>

                {/* Depósito + Cta. Depósito */}
                <div style={{ display: "flex", gap: "6px", marginBottom: "4px" }}>
                  <div style={{ flex: "0 0 44%" }}>
                    <div style={{ fontSize: "11px", marginBottom: "1px" }}>Depósito</div>
                    {condPago === "Contado"
                      ? <Input bsSize="sm" type="number" min="0" step="any" value={deposito} required onChange={(e) => jalaDeposito(e.target.value)} />
                      : <Input bsSize="sm" type="number" min="0" step="any" value={deposito} disabled />}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "11px", marginBottom: "1px" }}>Cta. Depósito</div>
                    {condPago === "Contado" && deposito > 0
                      ? <Input bsSize="sm" type="select" value={destinoDeposito} required onChange={(e) => setDestinoDeposito(e.target.value)}>
                          <option value="NA">Selecciona</option>
                          {bancos.map((b) => <option key={b._id} value={b.banco}>{b.banco}{b.cuenta !== "No" ? ` - ${b.cuenta}` : ""}</option>)}
                        </Input>
                      : <Input bsSize="sm" type="text" value={destinoDeposito} disabled />}
                  </div>
                </div>

                {/* Fecha Depósito */}
                <div style={{ display: "flex", gap: "6px", marginBottom: "4px" }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "11px", marginBottom: "1px" }}>Fecha Depósito</div>
                    {condPago === "Contado" && deposito > 0
                      ? <Input bsSize="sm" type="date" value={fechaDeposito} required onChange={(e) => setFechaDeposito(e.target.value)} />
                      : <Input bsSize="sm" type="date" value={fechaDeposito} disabled />}
                  </div>
                </div>

                {/* Cheque + Banco Destino */}
                <div style={{ display: "flex", gap: "6px", marginBottom: "4px" }}>
                  <div style={{ flex: "0 0 44%" }}>
                    <div style={{ fontSize: "11px", marginBottom: "1px" }}>Cheque</div>
                    {condPago === "Contado"
                      ? <Input bsSize="sm" type="number" min="0" step="any" value={cheque} required onChange={(e) => jalaCheque(e.target.value)} />
                      : <Input bsSize="sm" type="number" min="0" step="any" value={cheque} disabled />}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "11px", marginBottom: "1px" }}>Banco Cheque</div>
                    {condPago === "Contado" && cheque > 0
                      ? <Input bsSize="sm" type="select" value={destinoCheque} required onChange={(e) => setDestinoCheque(e.target.value)}>
                          <option value="NA">Selecciona</option>
                          {bancos.map((b) => <option key={b._id} value={b.banco}>{b.banco}{b.cuenta !== "No" ? ` - ${b.cuenta}` : ""}</option>)}
                        </Input>
                      : <Input bsSize="sm" type="text" value={destinoCheque} disabled />}
                  </div>
                </div>

                {/* No. Cheque + Fecha Cheque */}
                <div style={{ display: "flex", gap: "6px", marginBottom: "4px" }}>
                  <div style={{ flex: "0 0 44%" }}>
                    <div style={{ fontSize: "11px", marginBottom: "1px" }}>No. Cheque</div>
                    {condPago === "Contado" && cheque > 0
                      ? <Input bsSize="sm" type="text" value={numeroCheque} required onChange={(e) => setNumeroCheque(e.target.value)} />
                      : <Input bsSize="sm" type="text" value={numeroCheque} disabled />}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "11px", marginBottom: "1px" }}>Fecha Cheque</div>
                    {condPago === "Contado" && cheque > 0
                      ? <Input bsSize="sm" type="date" value={fechaCheque} required onChange={(e) => setFechaCheque(e.target.value)} />
                      : <Input bsSize="sm" type="date" value={fechaCheque} disabled />}
                  </div>
                </div>

                {/* Saldo */}
                <div style={{ display: "flex", gap: "6px", marginBottom: "4px" }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "11px", marginBottom: "1px" }}>Saldo</div>
                    <Input bsSize="sm" type="number" min="0" step="any" value={saldo} required disabled />
                  </div>
                </div>

                <hr className="my-2" />
                <div style={{ display: "flex", gap: "6px" }}>
                  {validaBoton
                    ? <Button type="submit" size="sm" className="btn btn-success" style={{ flex: 1 }} tabIndex={-1}>Guardar</Button>
                    : <Button type="submit" size="sm" className="btn btn-success" style={{ flex: 1 }} tabIndex={-1} disabled>Guardar</Button>}
                  <Button href="/MenuTiendas" size="sm" className="btn btn-danger" style={{ flex: 1 }} id="botonListado">Regresar</Button>
                </div>
              </Col>
              {/* PANEL DERECHO */}
              <Col md={9}>
                {urlPhoto && (
                  <div style={{ float: "right", width: "160px", marginLeft: "12px", marginBottom: "8px", border: "1px solid #ccc", borderRadius: "6px", background: "#fff", padding: "4px", textAlign: "center" }}>
                    <img src={urlPhoto} alt="Producto" style={{ width: "100%", height: "150px", objectFit: "contain" }} />
                  </div>
                )}
                {/* ── AGREGAR CAJA ── */}
                <p className="text-muted text-uppercase mb-1 mt-2" style={{ fontSize: "10px", letterSpacing: "1px", fontWeight: 600 }}>Agregar Caja</p>
                <>
                  {/* Agregar Caja — flex row, todos al mismo nivel */}
                  <div style={{ display: "flex", alignItems: "flex-end", gap: "8px", flexWrap: "wrap", marginBottom: "10px", fontSize: "12px" }}>
                    <div style={{ minWidth: "120px" }}>
                      <div style={{ fontSize: "11px", marginBottom: "2px" }}>Escanea el QR</div>
                      <Input
                        bsSize="sm"
                        name="articulos"
                        type="text"
                        autoComplete="off"
                        onChange={(e) => BuscaCodigoProporcion(inputArticulos[0].id, e)}
                      />
                    </div>
                    <div style={{ width: "220px" }}>
                      <div style={{ fontSize: "11px", marginBottom: "2px" }}>Selecciona</div>
                      <Autocomplete
                        size="small"
                        value={inputArticulos[0]?.articulosNombre || ""}
                        onChange={(event, selectedArticulo) => BuscaArticuloProporcion(inputArticulos[0]?.id || "template", selectedArticulo)}
                        options={options2.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                        groupBy={(option) => option.firstLetter}
                        getOptionLabel={(option) => option?.junta || ""}
                        renderInput={(params) => <TextField {...params} label="" variant="outlined" slotProps={{ input: { ...params.InputProps, style: { height: "31px", fontSize: "12px", padding: "0 30px 0 8px" } }, htmlInput: { ...params.inputProps, style: { padding: "0", fontSize: "12px" } } }} />}
                        renderOption={(props, option) => <li {...props} key={option._id}>{option.codigo} {option.nombre}</li>}
                      />
                    </div>
                    <div style={{ flex: 1, minWidth: "120px" }}>
                      <div style={{ fontSize: "11px", marginBottom: "2px" }}>Artículo</div>
                      <Input bsSize="sm" name="articulosNombre" type="string" placeholder="Articulo" value={inputArticulos[0].articulosNombre || ""} disabled style={{ width: "100%" }} />
                    </div>
                    <div style={{ width: "70px" }}>
                      <div style={{ fontSize: "11px", marginBottom: "2px" }}>Cajas</div>
                      <Input bsSize="sm" name="cajas" type="number" min="0" step="any" placeholder="Cajas" value={inputArticulos[0].cajas || ""} onChange={(e) => handleChangeInputProporcion(inputArticulos[0]?.id || "template", e)} />
                    </div>
                    <div style={{ width: "70px" }}>
                      <div style={{ fontSize: "11px", marginBottom: "2px" }}>Precio</div>
                      <Input bsSize="sm" name="precio" type="number" min="0" step="any" placeholder="Precio" value={inputArticulos[0]?.precio || ""} onChange={(e) => handleChangeInputProporcion(inputArticulos[0]?.id || "template", e)} />
                    </div>
                    <div>
                      <Button size="sm" color="success" disabled={!inputArticulos[0]?.articulos || !inputArticulos[0]?.cajas} onClick={() => agregarProporcion(inputArticulos[0]?.articulos, inputArticulos[0]?.articulosNombre, inputArticulos[0]?.precio, inputArticulos[0]?.cajas, inputArticulos[0]?.colores, inputArticulos[0]?.tallas)} tabindex="-1">Agregar</Button>
                    </div>
                  </div>

                  {/* ── AGREGAR PIEZA ── */}
                  <p className="text-muted text-uppercase mb-1" style={{ fontSize: "10px", letterSpacing: "1px", fontWeight: 600 }}>Agregar Pieza</p>

                  {/* Agregar Pieza — flex row, todos al mismo nivel */}
                  <div style={{ display: "flex", alignItems: "flex-end", gap: "8px", flexWrap: "wrap", marginBottom: "8px", fontSize: "12px" }}>
                    <div style={{ minWidth: "120px" }}>
                      <div style={{ fontSize: "11px", marginBottom: "2px" }}>Escanea QR / RFID</div>
                      <Input
                        bsSize="sm"
                        name="idProporcion"
                        type="text"
                        autoComplete="off"
                        innerRef={rfidScanRef}
                        onChange={(e) => buscarArticuloSingular(manualInput.id, e)}
                        onKeyDown={(e) => {
                          // Enter o Tab (segun el sufijo configurado en el lector)
                          if (
                            e.key === "Enter" ||
                            (e.key === "Tab" && e.target.value.trim())
                          ) {
                            e.preventDefault();
                            buscarArticuloSingular(manualInput.id, e);
                          }
                        }}
                      />
                      {(rfidStats.leidas > 0 ||
                        rfidStats.repetidas > 0 ||
                        rfidStats.noEncontradas > 0) && (
                        <small className="text-muted d-block">
                          RFID: {rfidStats.leidas} leídas · {rfidStats.repetidas}{" "}
                          repetidas · {rfidStats.noEncontradas} no encontradas
                        </small>
                      )}
                    </div>
                    <div style={{ width: "220px" }}>
                      <div style={{ fontSize: "11px", marginBottom: "2px" }}>Selecciona</div>
                      <Autocomplete
                        size="small"
                        value={manualInput?.articulosNombre || ""}
                        onChange={(event, selectedArticulo) => handleManualArticuloChange(selectedArticulo)}
                        options={options2.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                        groupBy={(option) => option.firstLetter}
                        getOptionLabel={(option) => option?.junta || ""}
                        renderInput={(params) => <TextField {...params} label="" variant="outlined" slotProps={{ input: { ...params.InputProps, style: { height: "31px", fontSize: "12px", padding: "0 30px 0 8px" } }, htmlInput: { ...params.inputProps, style: { padding: "0", fontSize: "12px" } } }} />}
                        renderOption={(props, option) => <li {...props} key={option._id}>{option.codigo} {option.nombre}</li>}
                      />
                    </div>
                    <div style={{ flex: 1, minWidth: "100px" }}>
                      <div style={{ fontSize: "11px", marginBottom: "2px" }}>Artículo</div>
                      <Input bsSize="sm" type="text" value={manualInput?.articulosNombre || ""} disabled style={{ width: "100%" }} />
                    </div>
                    <div style={{ width: "90px" }}>
                      <div style={{ fontSize: "11px", marginBottom: "2px" }}>Color</div>
                      <Input bsSize="sm" name="idColor" type="select" value={manualInput?.idColor || ""} onChange={handleManualInputChange}>
                        <option value="">Color</option>
                        {manualInput?.colores?.map((color) => <option key={color._id} value={color._id}>{color.name}</option>)}
                      </Input>
                    </div>
                    <div style={{ width: "80px" }}>
                      <div style={{ fontSize: "11px", marginBottom: "2px" }}>Talla</div>
                      <Input bsSize="sm" name="idTalla" type="select" value={manualInput.idTalla || ""} onChange={handleManualInputChange}>
                        <option value="">Talla</option>
                        {manualInput.tallas?.map((talla) => <option key={talla._id} value={talla._id}>{talla.name}</option>)}
                      </Input>
                    </div>
                    <div style={{ width: "65px" }}>
                      <div style={{ fontSize: "11px", marginBottom: "2px" }}>Cantidad</div>
                      <Input bsSize="sm" name="cantidad" type="number" min="0" step="any" placeholder="Cant." disabled={!manualInput?.idColor || !manualInput?.idTalla} value={manualInput?.cantidad || 0} onChange={handleManualInputChange} />
                    </div>
                    <div style={{ width: "70px" }}>
                      <div style={{ fontSize: "11px", marginBottom: "2px" }}>Precio</div>
                      <Input bsSize="sm" name="precio" type="number" value={manualInput?.precio || 0} onChange={handleManualInputChange} />
                    </div>
                    <div>
                      <Button size="sm" color="success" onClick={handleManualAdd} disabled={!manualInput?.articulosNombre || !manualInput?.idColor || !manualInput?.idTalla || !manualInput?.cantidad} tabindex="-1">Agregar</Button>
                    </div>
                  </div>
                </>

                <hr style={{ margin: "8px 0" }} />

                {/* ── TABLA DE ARTÍCULOS (compacta, sin expand/collapse) ── */}
                {inputFields.filter(f => f.articulosNombre && f.articulos).length > 0 && (
                  <table style={{ width: "100%", fontSize: "12px", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ background: "#f1f3f5", borderBottom: "2px solid #dee2e6" }}>
                        <th style={{ padding: "5px 8px", fontWeight: 600 }}>Artículo</th>
                        <th style={{ padding: "5px 6px", fontWeight: 600 }}>Color</th>
                        <th style={{ padding: "5px 6px", fontWeight: 600 }}>Tallas / Cant.</th>
                        <th style={{ padding: "5px 6px", fontWeight: 600, textAlign: "center", width: "50px" }}>Piezas</th>
                        <th style={{ padding: "5px 6px", fontWeight: 600, textAlign: "right", width: "65px" }}>Precio</th>
                        <th style={{ padding: "5px 6px", fontWeight: 600, textAlign: "right", width: "75px" }}>Total</th>
                        <th style={{ width: "28px" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(
                        inputFields
                          .filter(f => f.articulosNombre && f.articulos)
                          .reduce((acc, field) => {
                            const key = field.articulosNombre;
                            if (!acc[key]) {
                              acc[key] = {
                                articuloInfo: {
                                  articulosNombre: field.articulosNombre,
                                  articulos: field.articulos,
                                  availableTallas: Array.from(new Set(
                                    inputFields
                                      .filter(f => f.articulosNombre === field.articulosNombre)
                                      .map(f => f.tallaNombre)
                                      .filter(Boolean)
                                      .sort((a, b) => customSizeOrder.indexOf(a) - customSizeOrder.indexOf(b))
                                  )),
                                },
                                colorGroups: [],
                              };
                            }
                            const existingColorIndex = acc[key].colorGroups.findIndex(item => item.idColor === field.idColor);
                            if (existingColorIndex === -1) {
                              acc[key].colorGroups.push({
                                id: field.id,
                                articulos: field.articulos,
                                articulosNombre: field.articulosNombre,
                                idColor: field.idColor,
                                colorNombre: field.colorNombre,
                                colores: field.colores,
                                precioOriginal: field.precioOriginal,
                                precio: field.precio,
                                quantities: { [field.tallaNombre]: { cantidad: field.cantidad, id: field.id, cantInv: field.cantInv } },
                                total: field.cantidad * field.precio,
                              });
                            } else {
                              if (acc[key].colorGroups[existingColorIndex].quantities[field.tallaNombre]) {
                                acc[key].colorGroups[existingColorIndex].quantities[field.tallaNombre].cantidad += field.cantidad;
                              } else {
                                acc[key].colorGroups[existingColorIndex].quantities[field.tallaNombre] = { cantidad: field.cantidad, id: field.id, cantInv: field.cantInv };
                              }
                              acc[key].colorGroups[existingColorIndex].total += field.cantidad * field.precio;
                            }
                            return acc;
                          }, {})
                      ).flatMap(([articuloNombre, { articuloInfo, colorGroups }]) =>
                        colorGroups.map((group, groupIdx) => (
                          <tr
                            key={`${group.id}-${group.idColor}`}
                            style={{ borderBottom: "1px solid #f0f0f0", background: groupIdx % 2 === 0 ? "#fff" : "#fafafa" }}
                          >
                            {/* Artículo */}
                            <td style={{ padding: "5px 8px", maxWidth: "180px" }}>
                              <div style={{ fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={group.articulosNombre}>
                                {group.articulosNombre}
                              </div>
                            </td>

                            {/* Color */}
                            <td style={{ padding: "5px 6px", whiteSpace: "nowrap", color: "#555" }}>
                              {group.colorNombre}
                            </td>

                            {/* Tallas con cantidad editable + stock disponible */}
                            <td style={{ padding: "4px 6px" }}>
                              <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                                {Object.keys(group.quantities)
                                  .sort((a, b) => customSizeOrder.indexOf(a) - customSizeOrder.indexOf(b))
                                  .map(talla => (
                                  <div key={talla} style={{ textAlign: "center" }}>
                                    <div style={{ fontSize: "10px", color: "#888", lineHeight: 1 }}>{talla}</div>
                                    <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                      <input
                                        type="number"
                                        min="0"
                                        step="1"
                                        value={group.quantities[talla]?.cantidad || 0}
                                        onChange={(e) => {
                                          if (group.quantities[talla]?.id) {
                                            handleChangeInputCantidad(group.quantities[talla].id, e);
                                          } else {
                                            handleCreateNewArticuloTalla(group.articulos, group.idColor, talla, e.target.value, group.precio, group.colores);
                                          }
                                        }}
                                        style={{ width: "34px", fontSize: "12px", padding: "1px 2px", border: `1px solid ${parseFloat(group.quantities[talla]?.cantidad) === 0 ? "#e74c3c" : "#ccc"}`, borderRadius: "3px", textAlign: "center", backgroundColor: parseFloat(group.quantities[talla]?.cantidad) === 0 ? "#ffeaea" : "white" }}
                                      />
                                      <button
                                        type="button"
                                        onClick={() => handleRemoveFields(group.quantities[talla].id)}
                                        style={{ background: "#e74c3c", color: "white", border: "none", borderRadius: "3px", width: "20px", height: "20px", cursor: "pointer", fontSize: "12px", lineHeight: "20px", padding: 0, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}
                                      >×</button>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </td>

                            {/* Piezas totales del renglón */}
                            <td style={{ padding: "4px 6px", textAlign: "center" }}>
                              <span style={{
                                display: "inline-block",
                                background: "#e8f4fd",
                                color: "#1a73e8",
                                fontWeight: 600,
                                fontSize: "12px",
                                borderRadius: "4px",
                                padding: "2px 6px",
                                minWidth: "28px",
                              }}>
                                {Object.values(group.quantities).reduce((sum, q) => sum + (parseFloat(q.cantidad) || 0), 0)}
                              </span>
                            </td>

                            {/* Precio editable */}
                            <td style={{ padding: "4px 6px", textAlign: "right" }}>
                              <input
                                type="number"
                                min="0"
                                step="any"
                                name="precio"
                                value={group.precio}
                                onChange={(e) => handleChangeInput(group.id, e)}
                                required
                                style={{
                                  width: "58px",
                                  fontSize: "12px",
                                  padding: "2px 4px",
                                  border: `1px solid ${group.precioOriginal - 50 > group.precio ? "#e74c3c" : "#ccc"}`,
                                  borderRadius: "3px",
                                  textAlign: "right",
                                  backgroundColor: group.precioOriginal - 50 > group.precio ? "#ffeaea" : "white",
                                }}
                              />
                            </td>

                            {/* Total */}
                            <td style={{ padding: "5px 8px", textAlign: "right", fontWeight: 600, whiteSpace: "nowrap" }}>
                              ${group.total.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </td>

                            {/* Eliminar */}
                            <td style={{ padding: "4px", textAlign: "center" }}>
                              <button
                                type="button"
                                onClick={() => handleRemoveFields(group.id)}
                                style={{ background: "#e74c3c", color: "white", border: "none", borderRadius: "3px", width: "22px", height: "22px", cursor: "pointer", fontSize: "14px", lineHeight: 1 }}
                              >×</button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                )}

              </Col>
            </Row>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>

          <Modal
            size="sm"
            isOpen={modalCambiaPrecio}
            toggle={toggleCambiaPrecio}
          >
            <ModalHeader toggle={toggleCambiaPrecio}>
              <h4>Autorizar Precio</h4>
            </ModalHeader>
            <ModalBody>
              {mailAutEnviado === false ? (
                <Col>
                  <Button
                    type="submit"
                    className="btn btn-success"
                    onClick={(e) => solicitarAut()}
                  >
                    Solicitar Autorizacion
                  </Button>
                </Col>
              ) : (
                <>
                  <Input
                    bsSize="sm"
                    type="password"
                    placeholder="Password"
                    value={password}
                    required
                    onChange={(event) => setPassword(event.target.value)}
                  />
                  <br />
                  <Row>
                    <Col>
                      <Button
                        type="submit"
                        className="btn btn-success"
                        onClick={(e) => autorizaCambio()}
                      >
                        Autorizar
                      </Button>
                    </Col>

                    <Col>
                      <Button
                        type="submit"
                        className="btn btn-success"
                        onClick={(e) => solicitarAut()}
                      >
                        Reenviar Solicitud
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default VentasTiendasCreate;
